!(function (e) {
  "function" == typeof define && define.amd ? define("index", e) : e();
})(function () {
  "use strict";

  function e(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }

  function t(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        "value" in n && (n.writable = !0),
        Object.defineProperty(e, n.key, n);
    }
  }

  function i(e, i, n) {
    return i && t(e.prototype, i), n && t(e, n), e;
  }

  function n(e) {
    return (n = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
  }

  function o(e, t) {
    return (o =
      Object.setPrototypeOf ||
      function (e, t) {
        return (e.__proto__ = t), e;
      })(e, t);
  }

  function s() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {})
        ),
        !0
      );
    } catch (e) {
      return !1;
    }
  }

  function a(e, t, i) {
    return (a = s()
      ? Reflect.construct
      : function (e, t, i) {
          var n = [null];
          n.push.apply(n, t);
          var s = new (Function.bind.apply(e, n))();
          return i && o(s, i.prototype), s;
        }).apply(null, arguments);
  }

  function r(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (r = function (e) {
      if (
        null === e ||
        ((i = e), -1 === Function.toString.call(i).indexOf("[native code]"))
      )
        return e;
      var i;
      if ("function" != typeof e)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, s);
      }

      function s() {
        return a(e, arguments, n(this).constructor);
      }
      return (
        (s.prototype = Object.create(e.prototype, {
          constructor: {
            value: s,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
        o(s, e)
      );
    })(e);
  }

  function l(e, t) {
    return !t || ("object" != typeof t && "function" != typeof t)
      ? (function (e) {
          if (void 0 === e)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return e;
        })(e)
      : t;
  }
  var c = (function () {
      function t() {
        var i = this;
        e(this, t),
          (this.currentBreakpoint = t.getCurrentBreakpoint()),
          window.addEventListener("resize", function () {
            var e = t.getCurrentBreakpoint();
            i.currentBreakpoint !== e &&
              (document.dispatchEvent(
                new CustomEvent("breakpoint:changed", {
                  detail: {
                    previousBreakpoint: i.currentBreakpoint,
                    currentBreakpoint: e,
                  },
                })
              ),
              (i.currentBreakpoint = e));
          });
      }
      return (
        i(t, null, [
          {
            key: "matchesBreakpoint",
            value: function (e) {
              switch (e) {
                case "phone":
                  return window.matchMedia("screen and (max-width: 640px)")
                    .matches;
                case "tablet":
                  return window.matchMedia(
                    "screen and (min-width: 641px) and (max-width: 1007px)"
                  ).matches;
                case "tablet-and-up":
                  return window.matchMedia("screen and (min-width: 641px)")
                    .matches;
                case "pocket":
                  return window.matchMedia("screen and (max-width: 1007px)")
                    .matches;
                case "lap":
                  return window.matchMedia(
                    "screen and (min-width: 1008px) and (max-width: 1279px)"
                  ).matches;
                case "lap-and-up":
                  return window.matchMedia("screen and (min-width: 1008px)")
                    .matches;
                case "desk":
                  return window.matchMedia("screen and (min-width: 1280px)")
                    .matches;
                case "widescreen":
                  return window.matchMedia("screen and (min-width: 1600px)")
                    .matches;
                case "supports-hover":
                  return window.matchMedia("(hover: hover) and (pointer: fine)")
                    .matches;
              }
            },
          },
          {
            key: "getCurrentBreakpoint",
            value: function () {
              return window.matchMedia("screen and (max-width: 640px)").matches
                ? "phone"
                : window.matchMedia(
                    "screen and (min-width: 641px) and (max-width: 1007px)"
                  ).matches
                ? "tablet"
                : window.matchMedia(
                    "screen and (min-width: 1008px) and (max-width: 1279px)"
                  ).matches
                ? "lap"
                : window.matchMedia("screen and (min-width: 1280px)").matches
                ? "desk"
                : void 0;
            },
          },
        ]),
        t
      );
    })(),
    d = (function () {
      function t(i) {
        var n =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          o =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        e(this, t),
          (this.element = i),
          (this.initialConfig = Object.assign(
            JSON.parse(i.getAttribute("data-flickity-config")),
            o
          )),
          (this.options = n),
          this._attachListeners(),
          this._build();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.flickityInstance.destroy(),
                void 0 !== this.initialConfig.breakpoints &&
                  document.removeEventListener(
                    "breakpoint:changed",
                    this._onBreakpointChangedListener
                  );
            },
          },
          {
            key: "getFlickityInstance",
            value: function () {
              return this.flickityInstance;
            },
          },
          {
            key: "selectCell",
            value: function (e) {
              var t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                i =
                  !(arguments.length > 2 && void 0 !== arguments[2]) ||
                  arguments[2];
              t && this.flickityInstance.pausePlayer(),
                this.flickityInstance.select(e, !1, !i);
            },
          },
          {
            key: "next",
            value: function () {
              this.flickityInstance.next();
            },
          },
          {
            key: "previous",
            value: function () {
              this.flickityInstance.previous();
            },
          },
          {
            key: "pausePlayer",
            value: function () {
              this.flickityInstance.pausePlayer();
            },
          },
          {
            key: "unpausePlayer",
            value: function () {
              this.flickityInstance.unpausePlayer();
            },
          },
          {
            key: "resize",
            value: function () {
              this.flickityInstance.resize();
            },
          },
          {
            key: "getSelectedIndex",
            value: function () {
              return this.flickityInstance.selectedIndex;
            },
          },
          {
            key: "getSelectedCell",
            value: function () {
              return this.flickityInstance.selectedCell.element;
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              void 0 !== this.initialConfig.breakpoints &&
                ((this._onBreakpointChangedListener =
                  this._onBreakpointChanged.bind(this)),
                document.addEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                ));
            },
          },
          {
            key: "_build",
            value: function () {
              var e = this,
                t = this._processConfig();
              (this.flickityInstance = new Flickity(this.element, t)),
                this._validateDraggable(),
                (this.selectedIndex = this.flickityInstance.selectedIndex),
                this.flickityInstance.on(
                  "resize",
                  this._validateDraggable.bind(this)
                ),
                this.options.onSelect &&
                  this.flickityInstance.on("select", function () {
                    e.selectedIndex !== e.flickityInstance.selectedIndex &&
                      (e.options.onSelect(
                        e.flickityInstance.selectedIndex,
                        e.flickityInstance.selectedCell.element
                      ),
                      (e.selectedIndex = e.flickityInstance.selectedIndex));
                  }),
                this.options.onSettle &&
                  this.flickityInstance.on("settle", function (t) {
                    e.options.onSettle(
                      t,
                      e.flickityInstance.selectedCell.element
                    );
                  }),
                this.options.onClick &&
                  this.flickityInstance.on(
                    "staticClick",
                    function (t, i, n, o) {
                      e.options.onClick(n, o);
                    }
                  );
            },
          },
          {
            key: "_validateDraggable",
            value: function () {
              (this.flickityInstance.isActive || !1) &&
                this.flickityInstance.options.draggable &&
                (void 0 === this.flickityInstance.selectedElements ||
                this.flickityInstance.selectedElements.length ===
                  this.flickityInstance.cells.length
                  ? this.flickityInstance.unbindDrag()
                  : this.flickityInstance.bindDrag());
            },
          },
          {
            key: "_processConfig",
            value: function () {
              var e = Object.assign({}, this.initialConfig);
              return (
                delete e.breakpoints,
                void 0 === this.initialConfig.breakpoints
                  ? e
                  : (this.initialConfig.breakpoints.forEach(function (t) {
                      c.matchesBreakpoint(t.matches) &&
                        (e = Object.assign(e, t.settings));
                    }),
                    e)
              );
            },
          },
          {
            key: "_onBreakpointChanged",
            value: function () {
              this.flickityInstance.destroy(), this._build();
            },
          },
        ]),
        t
      );
    })(),
    u = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "slideUp",
            value: function (e) {
              (e.style.height = "".concat(e.scrollHeight, "px")),
                e.offsetHeight,
                (e.style.height = 0);
            },
          },
          {
            key: "slideDown",
            value: function (e) {
              if ("auto" !== e.style.height) {
                e.style.height = "".concat(
                  e.firstElementChild.scrollHeight,
                  "px"
                );
                e.addEventListener("transitionend", function t(i) {
                  "height" === i.propertyName &&
                    ((e.style.height = "auto"),
                    e.removeEventListener("transitionend", t));
                });
              }
            },
          },
        ]),
        t
      );
    })(),
    h = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "getSiblings",
            value: function (e, t) {
              for (
                var i =
                    arguments.length > 2 &&
                    void 0 !== arguments[2] &&
                    arguments[2],
                  n = [],
                  o = e;
                (o = o.previousElementSibling);

              )
                (t && !o.matches(t)) || n.push(o);
              for (i && n.push(e), o = e; (o = o.nextElementSibling); )
                (t && !o.matches(t)) || n.push(o);
              return n;
            },
          },
          {
            key: "nodeListToArray",
            value: function (e, t) {
              for (var i = [], n = 0; n !== e.length; ++n)
                (t && !e[n].matches(t)) || i.push(e[n]);
              return i;
            },
          },
          {
            key: "outerWidthWithMargin",
            value: function (e) {
              var t = e.offsetWidth,
                i = getComputedStyle(e);
              return (t += parseInt(i.marginLeft) + parseInt(i.marginRight));
            },
          },
          {
            key: "outerHeightWithMargin",
            value: function (e) {
              var t = e.offsetHeight,
                i = getComputedStyle(e);
              return (t += parseInt(i.marginTop) + parseInt(i.marginBottom));
            },
          },
        ]),
        t
      );
    })(),
    m = (function () {
      function t() {
        e(this, t),
          (this.domDelegate = new domDelegate.Delegate(document.body)),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "_attachListeners",
            value: function () {
              this.domDelegate.on(
                "click",
                '[data-action="toggle-collapsible"]',
                this._toggleCollapsible.bind(this)
              );
            },
          },
          {
            key: "_toggleCollapsible",
            value: function (e, t) {
              var i = this,
                n = t.closest(".Collapsible");
              (n.classList.contains("Collapsible--autoExpand") &&
                c.matchesBreakpoint("tablet-and-up")) ||
                ("true" === t.getAttribute("aria-expanded")
                  ? this._close(n, t)
                  : this._open(n, t),
                h.getSiblings(n).forEach(function (e) {
                  return i._close(e);
                }),
                e.preventDefault());
            },
          },
          {
            key: "_open",
            value: function (e) {
              var t = e.querySelector(".Collapsible__Button"),
                i = e.querySelector(".Collapsible__Inner");
              i &&
                "true" !== t.getAttribute("aria-expanded") &&
                (t.setAttribute("aria-expanded", "true"),
                (i.style.overflow = "visible"),
                u.slideDown(i),
                setTimeout(function () {
                  e.style.overflow = "visible";
                }, 350));
            },
          },
          {
            key: "_close",
            value: function (e) {
              var t = e.querySelector(".Collapsible__Button"),
                i = e.querySelector(".Collapsible__Inner");
              i &&
                "false" !== t.getAttribute("aria-expanded") &&
                (t.setAttribute("aria-expanded", "false"),
                (i.style.overflow = "hidden"),
                (e.style.overflow = "hidden"),
                u.slideUp(i));
            },
          },
        ]),
        t
      );
    })(),
    p = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "trapFocus",
            value: function (e, t) {
              this.listeners = this.listeners || {};
              var i = e.querySelector("[autofocus]") || e;
              e.setAttribute("tabindex", "-1"),
                i.focus(),
                (this.listeners[t] = function (t) {
                  e === t.target || e.contains(t.target) || e.focus();
                }),
                document.addEventListener("focusin", this.listeners[t]);
            },
          },
          {
            key: "removeTrapFocus",
            value: function (e, t) {
              e && e.removeAttribute("tabindex"),
                this.listeners &&
                  this.listeners[t] &&
                  document.removeEventListener("focusin", this.listeners[t]);
            },
          },
          {
            key: "clearTrapFocus",
            value: function () {
              for (var e in this.listeners)
                this.listeners.hasOwnProperty(e) &&
                  document.removeEventListener("focusin", this.listeners[e]);
              this.listeners = {};
            },
          },
        ]),
        t
      );
    })(),
    v = (function () {
      function t(i) {
        var n =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.delegateBody = new domDelegate.Delegate(document.body)),
          (this.onOpen = n.onOpen || function () {}),
          (this.onClose = n.onClose || function () {}),
          (this.isOpen = !1),
          (this.direction = this.element.classList.contains("Drawer--fromLeft")
            ? "fromLeft"
            : "fromRight"),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.delegateBody.off(
                "click",
                '[data-action="open-drawer"][data-drawer-id="'.concat(
                  this.element.id,
                  '"]'
                )
              ),
                this.delegateBody.off(
                  "click",
                  '[data-action="close-drawer"][data-drawer-id="'.concat(
                    this.element.id,
                    '"]'
                  )
                ),
                window.removeEventListener(
                  "resize",
                  this._calculateMaxHeightListener
                );
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.close() : this.open();
            },
          },
          {
            key: "open",
            value: function (e) {
              if (!this.isOpen)
                return (
                  this.element.dispatchEvent(
                    new CustomEvent("search:close", {
                      bubbles: !0,
                    })
                  ),
                  e && e.preventDefault(),
                  this.element.setAttribute("aria-hidden", "false"),
                  this._calculateMaxHeight(),
                  document.documentElement.classList.add("no-scroll"),
                  p.trapFocus(this.element, "drawer"),
                  (document.querySelector(
                    "#shopify-section-header"
                  ).style.zIndex = ""),
                  this.pageOverlayElement.classList.add("is-visible"),
                  this.pageOverlayElement.addEventListener(
                    "click",
                    this._closeListener
                  ),
                  (this.isOpen = !0),
                  this.onOpen(),
                  !1
                );
            },
          },
          {
            key: "close",
            value: function (e) {
              this.isOpen &&
                (e && e.preventDefault(),
                this.element.setAttribute("aria-hidden", "true"),
                document.documentElement.classList.remove("no-scroll"),
                p.removeTrapFocus(this.element, "drawer"),
                this.pageOverlayElement.classList.remove("is-visible"),
                this.pageOverlayElement.removeEventListener(
                  "click",
                  this._closeListener
                ),
                (this.isOpen = !1),
                this.onClose());
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._openListener = this.open.bind(this)),
                (this._closeListener = this.close.bind(this)),
                (this._calculateMaxHeightListener =
                  this._calculateMaxHeight.bind(this)),
                this.delegateBody.on(
                  "click",
                  '[data-action="open-drawer"][data-drawer-id="'.concat(
                    this.element.id,
                    '"]'
                  ),
                  this._openListener
                ),
                this.delegateBody.on(
                  "click",
                  '[data-action="close-drawer"][data-drawer-id="'.concat(
                    this.element.id,
                    '"]'
                  ),
                  this._closeListener
                ),
                this.element.addEventListener(
                  "keyup",
                  this._handleKeyboard.bind(this)
                ),
                window.addEventListener(
                  "resize",
                  this._calculateMaxHeightListener
                );
            },
          },
          {
            key: "_calculateMaxHeight",
            value: function () {
              this.element.style.maxHeight = window.innerHeight + "px";
            },
          },
          {
            key: "_handleKeyboard",
            value: function (e) {
              this.isOpen && 27 === e.keyCode && this.close();
            },
          },
        ]),
        t
      );
    })(),
    f = (function () {
      function t() {
        e(this, t),
          (this.element = document.querySelector(".LoadingBar")),
          document.addEventListener(
            "theme:loading:start",
            this._onLoadingStart.bind(this)
          ),
          document.addEventListener(
            "theme:loading:end",
            this._onLoadingEnd.bind(this)
          ),
          this.element.addEventListener(
            "transitionend",
            this._onTransitionEnd.bind(this)
          );
      }
      return (
        i(t, [
          {
            key: "_onLoadingStart",
            value: function () {
              this.element.classList.add("is-visible"),
                (this.element.style.width = "40%");
            },
          },
          {
            key: "_onLoadingEnd",
            value: function () {
              (this.element.style.width = "100%"),
                this.element.classList.add("is-finished");
            },
          },
          {
            key: "_onTransitionEnd",
            value: function (e) {
              "width" === e.propertyName &&
                this.element.classList.contains("is-finished") &&
                (this.element.classList.remove("is-visible"),
                this.element.classList.remove("is-finished"),
                (this.element.style.width = "0"));
            },
          },
        ]),
        t
      );
    })(),
    y = (function () {
      function t() {
        e(this, t),
          (this.domDelegate = new domDelegate.Delegate(document.body)),
          (this.activeModal = null),
          (this.wasLocked = !1),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners(),
          this._checkOpenByHash();
      }
      return (
        i(t, [
          {
            key: "_attachListeners",
            value: function () {
              (this._closeListener = this._closeModal.bind(this)),
                (this._handleKeyboardListener =
                  this._handleKeyboard.bind(this)),
                this.domDelegate.on(
                  "click",
                  '[data-action="open-modal"]',
                  this._openModalEvent.bind(this)
                ),
                this.domDelegate.on(
                  "click",
                  '[data-action="close-modal"]',
                  this._closeModal.bind(this)
                );
            },
          },
          {
            key: "_openModalEvent",
            value: function (e, t) {
              this._openModal(
                document.getElementById(t.getAttribute("aria-controls"))
              ),
                e.preventDefault(),
                e.stopPropagation();
            },
          },
          {
            key: "_openModal",
            value: function (e) {
              var t = this;
              !this.activeModal &&
                e &&
                ((this.activeModal = e),
                this.domDelegate.on("keyup", this._handleKeyboardListener),
                document.documentElement.classList.contains("no-scroll") &&
                  (this.wasLocked = !0),
                fastdom.mutate(function () {
                  p.clearTrapFocus(),
                    (t._onTransitionEndedListener =
                      t._onTransitionEnded.bind(t)),
                    t.activeModal.addEventListener(
                      "transitionend",
                      t._onTransitionEndedListener
                    ),
                    t.activeModal.setAttribute("aria-hidden", "false"),
                    document.documentElement.classList.add("no-scroll"),
                    t.activeModal.classList.contains("Modal--fullScreen") ||
                      (t.pageOverlayElement.classList.add("is-visible"),
                      t.pageOverlayElement.addEventListener(
                        "click",
                        t._closeListener
                      ));
                }));
            },
          },
          {
            key: "_closeModal",
            value: function () {
              var e = this;
              this.activeModal &&
                (this.activeModal.removeEventListener(
                  "keyup",
                  this._handleKeyboardListener
                ),
                this.domDelegate.off("keyup"),
                fastdom.mutate(function () {
                  e.activeModal.classList.contains("Modal--videoContent") &&
                    ((e._resetVideoListener = e._resetVideo.bind(e)),
                    e.activeModal.addEventListener(
                      "transitionend",
                      e._resetVideoListener
                    )),
                    p.removeTrapFocus(e.activeModal, "modal"),
                    e.activeModal.classList.contains("Modal--fullScreen") ||
                      (e.pageOverlayElement.classList.remove("is-visible"),
                      e.pageOverlayElement.removeEventListener(
                        "click",
                        e._closeListener
                      )),
                    e.activeModal.setAttribute("aria-hidden", "true"),
                    (e.activeModal = null),
                    e.wasLocked ||
                      document.documentElement.classList.remove("no-scroll");
                }));
            },
          },
          {
            key: "_onTransitionEnded",
            value: function (e) {
              "visibility" === e.propertyName &&
                (p.trapFocus(this.activeModal, "modal"),
                this.activeModal.removeEventListener(
                  "transitionend",
                  this._onTransitionEndedListener
                ));
            },
          },
          {
            key: "_resetVideo",
            value: function (e) {
              if ("visibility" === e.propertyName) {
                var t = e.target.querySelector("iframe");
                (t.parentNode.innerHTML =
                  '<iframe class="Image--lazyLoad" data-src='.concat(
                    t.getAttribute("data-src"),
                    ' frameborder="0" allowfullscreen>'
                  )),
                  e.target.removeEventListener(
                    "transitionend",
                    this._resetVideoListener
                  );
              }
            },
          },
          {
            key: "_checkOpenByHash",
            value: function () {
              var e = window.location.hash,
                t = document.getElementById(e.replace("#", ""));
              t && t.classList.contains("Modal") && this._openModal(t);
            },
          },
          {
            key: "_handleKeyboard",
            value: function (e) {
              null !== this.activeModal &&
                27 === e.keyCode &&
                this._closeModal();
            },
          },
        ]),
        t
      );
    })(),
    g = (function () {
      function t(i, n) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.activator =
            n.activator ||
            document.querySelector(
              '[aria-controls="'.concat(i.getAttribute("id"), '"]')
            )),
          (this.preferredPosition = n.preferredPosition || "bottom"),
          (this.preferredAlignment = n.preferredAlignment || void 0),
          (this.threshold = n.threshold || 20),
          (this.isOpen = !1),
          (this.onValueChanged = n.onValueChanged || function () {}),
          (this.onOpen = n.onOpen || function () {}),
          (this.onClose = n.onClose || function () {}),
          (this.showOverlay = void 0 === n.showOverlay || n.showOverlay),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.element.removeEventListener(
                "keyup",
                this._handleKeyboardListener
              ),
                this.delegateElement.off("click"),
                this.activator.removeEventListener(
                  "click",
                  this._toggleListener
                );
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.close() : this.open();
            },
          },
          {
            key: "open",
            value: function () {
              var e = this;
              this.isOpen ||
                this.activator.getAttribute("aria-controls") !==
                  this.element.id ||
                (this.element.setAttribute("aria-hidden", "false"),
                this.activator.setAttribute("aria-expanded", "true"),
                disableBodyScroll(!0, "[data-scrollable]"),
                document.documentElement.classList.add("no-scroll"),
                c.matchesBreakpoint("lap-and-up")
                  ? (document.body.addEventListener(
                      "click",
                      this._clickOutsideListener
                    ),
                    this._position(),
                    this.element.setAttribute("tabindex", "-1"),
                    this.element.addEventListener(
                      "transitionend",
                      function () {
                        e.element.focus();
                      },
                      {
                        once: !0,
                      }
                    ))
                  : (this.element.removeAttribute("style"),
                    this.showOverlay &&
                      (this.pageOverlayElement.classList.add("is-visible"),
                      this.pageOverlayElement.addEventListener(
                        "click",
                        this._closeListener
                      ))),
                this.onOpen(this),
                (this.isOpen = !0));
            },
          },
          {
            key: "close",
            value: function () {
              this.isOpen &&
                (this.element.setAttribute("aria-hidden", "true"),
                this.activator.setAttribute("aria-expanded", "false"),
                disableBodyScroll(!1, "[data-scrollable]"),
                document.documentElement.classList.remove("no-scroll"),
                c.matchesBreakpoint("lap-and-up")
                  ? document.body.removeEventListener(
                      "click",
                      this._clickOutsideListener
                    )
                  : this.showOverlay &&
                    (this.pageOverlayElement.classList.remove("is-visible"),
                    this.pageOverlayElement.removeEventListener(
                      "click",
                      this._closeListener
                    )),
                this.element.removeAttribute("tabindex"),
                this.activator.focus(),
                this.onClose(this),
                (this.isOpen = !1));
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._handleKeyboardListener = this._handleKeyboard.bind(this)),
                (this._clickOutsideListener = this._clickOutside.bind(this)),
                (this._closeListener = this.close.bind(this)),
                (this._toggleListener = this.toggle.bind(this)),
                this.element.addEventListener(
                  "keyup",
                  this._handleKeyboardListener
                ),
                this.activator.addEventListener("click", this._toggleListener),
                this.delegateElement.on(
                  "click",
                  '[data-action="close-popover"]',
                  this.close.bind(this)
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="select-value"]',
                  this._valueChanged.bind(this)
                ),
                this.element.hasAttribute("id") &&
                  this.delegateElement.on(
                    "focusout",
                    "#".concat(this.element.getAttribute("id")),
                    this._onFocusOut.bind(this)
                  );
            },
          },
          {
            key: "_valueChanged",
            value: function (e) {
              h.getSiblings(e.target, ".is-selected").forEach(function (e) {
                return e.classList.remove("is-selected");
              }),
                e.target.classList.add("is-selected"),
                this.onValueChanged(
                  e.target.getAttribute("data-value"),
                  e.target,
                  this.activator
                ),
                this.close();
            },
          },
          {
            key: "_onFocusOut",
            value: function (e) {
              this.element.contains(e.relatedTarget);
            },
          },
          {
            key: "_clickOutside",
            value: function (e) {
              e.target.closest(".Popover") ||
                e.target.closest(".Modal") ||
                e.target === this.activator ||
                this.activator.contains(e.target) ||
                this.close();
            },
          },
          {
            key: "_position",
            value: function () {
              var e = this,
                t = 0,
                i = 0,
                n = "",
                o = "",
                s = this.threshold;
              fastdom.measure(function () {
                var a = window.innerHeight,
                  r = e.activator.getBoundingClientRect(),
                  l = a / 2;
                if ("bottom" === e.preferredPosition)
                  (o = "right"),
                    (n =
                      e.element.clientHeight <= a - (r.bottom + s) ||
                      a - r.bottom >= l
                        ? "bottom"
                        : "top");
                else if ("top" === e.preferredPosition)
                  (o = "right"),
                    (n =
                      e.element.clientHeight <= r.top - s || r.top >= l
                        ? "top"
                        : "bottom");
                else {
                  n = "left";
                  var c = e.element.clientHeight / 2;
                  o =
                    r.top >= c && a - r.bottom >= c
                      ? "center"
                      : a - r.bottom >= c
                      ? "bottom"
                      : "top";
                }
                e.preferredAlignment && (o = e.preferredAlignment),
                  "top" === n
                    ? ((t = r.top - e.element.clientHeight - s),
                      (i =
                        "center" === o
                          ? window.innerWidth -
                            r.right -
                            e.element.clientWidth / 2 +
                            3
                          : window.innerWidth - r.right))
                    : "bottom" === n
                    ? ((t = r.bottom + s),
                      (i =
                        "center" === o
                          ? window.innerWidth -
                            r.right -
                            e.element.clientWidth / 2 +
                            3
                          : window.innerWidth - r.right))
                    : ((i = window.innerWidth - r.left + s),
                      (t =
                        "center" === o
                          ? r.top -
                            e.element.clientHeight / 2 +
                            e.activator.clientHeight / 2
                          : "top" === o
                          ? r.bottom - e.element.clientHeight
                          : r.top));
              }),
                fastdom.mutate(function () {
                  [
                    "Popover--positionBottom",
                    "Popover--positionTop",
                    "Popover--positionCenter",
                    "Popover--alignTop",
                    "Popover--alignCenter",
                    "Popover--alignBottom",
                  ].map(function (t) {
                    return e.element.classList.remove(t);
                  }),
                    e.element.classList.add(
                      "Popover--position".concat(
                        n.charAt(0).toUpperCase() + n.slice(1)
                      )
                    ),
                    e.element.classList.add(
                      "Popover--align".concat(
                        o.charAt(0).toUpperCase() + o.slice(1)
                      )
                    ),
                    e.element.setAttribute(
                      "style",
                      "top: "
                        .concat(parseInt(t), "px; right: ")
                        .concat(parseInt(i), "px;")
                    );
                });
            },
          },
          {
            key: "_handleKeyboard",
            value: function (e) {
              this.isOpen && 27 === e.keyCode && this.close();
            },
          },
        ]),
        t
      );
    })(),
    _ = (function () {
      function t() {
        e(this, t),
          (this.domDelegate = new domDelegate.Delegate(document.body)),
          (this.pageTransition = document.querySelector(".PageTransition")),
          this._attachListeners();
      }
      return (
        i(
          t,
          [
            {
              key: "_attachListeners",
              value: function () {
                this.domDelegate.on(
                  "click",
                  'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
                  this._onPageUnload.bind(this)
                );
              },
            },
            {
              key: "_onPageUnload",
              value: function (e, t) {
                var i = this;
                if (
                  !(e.defaultPrevented || e.ctrlKey || e.metaKey) &&
                  window.theme.showPageTransition &&
                  this.pageTransition &&
                  (e.preventDefault(),
                  window.theme.showPageTransition && this.pageTransition)
                ) {
                  this.pageTransition.addEventListener(
                    "transitionend",
                    function e(n) {
                      "opacity" === n.propertyName &&
                        (i.pageTransition.removeEventListener(
                          "transitionend",
                          e
                        ),
                        (window.location.href = t.href));
                    }
                  ),
                    (this.pageTransition.style.visibility = "visible"),
                    (this.pageTransition.style.opacity = "1");
                }
              },
            },
          ],
          [
            {
              key: "getInstance",
              value: function () {
                return (
                  this.instance || (this.instance = new t()), this.instance
                );
              },
            },
          ]
        ),
        t
      );
    })(),
    w = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          this.delegateElement.on(
            "change",
            ".ColorSwatch__Radio",
            this._colorChanged.bind(this)
          );
      }
      return (
        i(t, [
          {
            key: "_colorChanged",
            value: function (e, t) {
              var i = t.closest(".ProductItem"),
                n = t.getAttribute("data-variant-url");
              i
                .querySelector(".ProductItem__ImageWrapper")
                .setAttribute("href", n),
                i
                  .querySelector(".ProductItem__Title > a")
                  .setAttribute("href", n);
              var o = i.querySelector(
                ".ProductItem__Image:not(.ProductItem__Image--alternate)"
              );
              if (
                t.hasAttribute("data-image-url") &&
                t.getAttribute("data-image-id") !==
                  o.getAttribute("data-image-id")
              ) {
                var s = document.createElement("img");
                (s.className =
                  "ProductItem__Image Image--fadeIn Image--lazyLoad"),
                  s.setAttribute(
                    "data-image-id",
                    t.getAttribute("data-image-id")
                  ),
                  s.setAttribute("data-src", t.getAttribute("data-image-url")),
                  s.setAttribute(
                    "data-widths",
                    t.getAttribute("data-image-widths")
                  ),
                  s.setAttribute("data-sizes", "auto"),
                  "natural" === window.theme.productImageSize &&
                    (o.parentNode.style.paddingBottom = "".concat(
                      100 / t.getAttribute("data-image-aspect-ratio"),
                      "%"
                    )),
                  o.parentNode.style.setProperty(
                    "--aspect-ratio",
                    t.getAttribute("data-image-aspect-ratio")
                  ),
                  o.parentNode.replaceChild(s, o);
              }
            },
          },
        ]),
        t
      );
    })(),
    b = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "getSizedImageUrl",
            value: function (e, t) {
              if (null === t) return e;
              if ("master" === t) return e.replace(/http(s)?:/, "");
              var i = e.match(
                /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
              );
              if (i) {
                var n = e.split(i[0]),
                  o = i[0];
                return (n[0] + "_" + t + o).replace(/http(s)?:/, "");
              }
              return null;
            },
          },
          {
            key: "getSupportedSizes",
            value: function (e, t) {
              var i = [],
                n = e.width;
              return (
                t.forEach(function (e) {
                  n >= e && i.push(e);
                }),
                i
              );
            },
          },
        ]),
        t
      );
    })(),
    k = (function () {
      function t(i, n) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.delegateRoot = new domDelegate.Delegate(document.body)),
          (this.slideshow = n),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.delegateElement.off("click");
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                '[data-action="open-product-zoom"]',
                this._initPhotoSwipe.bind(this)
              ),
                this.delegateElement.on(
                  "click",
                  ".Product__SlideItem--image",
                  this._initPhotoSwipeFromImageClick.bind(this)
                );
            },
          },
          {
            key: "_initPhotoSwipe",
            value: function () {
              var e = [];
              this.slideshow.flickityInstance.cells.forEach(function (t) {
                t.element.classList.contains("Product__SlideItem--image") &&
                  e.push(t.element.querySelector("img"));
              }),
                this._createPhotoSwipeInstance(
                  this._createPhotoSwipeItemsFromImages(e),
                  parseInt(
                    this.slideshow.flickityInstance.selectedElement.getAttribute(
                      "data-image-media-position"
                    )
                  )
                );
            },
          },
          {
            key: "_initPhotoSwipeFromImageClick",
            value: function (e, t) {
              if (!c.matchesBreakpoint("pocket")) {
                var i = h.nodeListToArray(
                  this.element.querySelectorAll(
                    ".Product__SlideItem--image img"
                  )
                );
                this._createPhotoSwipeInstance(
                  this._createPhotoSwipeItemsFromImages(i),
                  parseInt(t.getAttribute("data-image-media-position"))
                );
              }
            },
          },
          {
            key: "_createPhotoSwipeItemsFromImages",
            value: function (e) {
              return e.map(function (e) {
                var t = parseInt(e.getAttribute("data-max-width")),
                  i = parseInt(e.getAttribute("data-max-height")),
                  n = c.matchesBreakpoint("phone") ? 1200 : 1800,
                  o = 1;
                o = t >= i ? Math.max(t / n, 1) : Math.max(i / n, 1);
                var s = Math.floor(t / o),
                  a = Math.floor(i / o);
                return {
                  msrc: e.currentSrc || e.src,
                  w: s,
                  h: a,
                  initialZoomLevel: 0.65,
                  src: b.getSizedImageUrl(
                    e.getAttribute("data-original-src"),
                    s + "x" + a
                  ),
                };
              });
            },
          },
          {
            key: "_createPhotoSwipeInstance",
            value: function (e, t) {
              var i = this,
                n = document.querySelector(".pswp");
              (this.photoSwipeInstance = new PhotoSwipe(n, !1, e, {
                index: t,
                showHideOpacity: !0,
                showAnimationDuration: 500,
                loop: !1,
                history: !1,
                closeOnVerticalDrag: !1,
                allowPanToNext: !1,
                pinchToClose: !1,
                errorMsg:
                  '<p class="pswp__error-msg">' +
                  window.languages.productImageLoadingError +
                  "</p>",
                scaleMode: "zoom",
                getDoubleTapZoom: function (e, t) {
                  return e ? 1.6 : t.initialZoomLevel < 0.7 ? 1 : 1.33;
                },
                getThumbBoundsFn: function (e) {
                  var t = i.element.querySelector(
                      '.Product__Slideshow .Carousel__Cell[data-image-media-position="'.concat(
                        parseInt(e),
                        '"] img'
                      )
                    ),
                    n =
                      window.pageYOffset || document.documentElement.scrollTop,
                    o = t.getBoundingClientRect();
                  return {
                    x: o.left,
                    y: o.top + n,
                    w: o.width,
                  };
                },
              })),
                this.photoSwipeInstance.listen(
                  "beforeChange",
                  this._onSlideChanged.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "destroy",
                  this._destroyPhotoSwipe.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "doubleTap",
                  this._onDoubleTap.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "initialZoomIn",
                  this._onInitialZoomIn.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "initialZoomOut",
                  this._onInitialZoomOut.bind(this)
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__scroll-wrap",
                  this._onSingleTap.bind(this)
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__button--close",
                  this.photoSwipeInstance.close
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__button--prev",
                  this.photoSwipeInstance.prev
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__button--next",
                  this.photoSwipeInstance.next
                ),
                this.photoSwipeInstance.init();
            },
          },
          {
            key: "_onSlideChanged",
            value: function () {
              0 === this.photoSwipeInstance.getCurrentIndex()
                ? this.photoSwipeInstance.scrollWrap
                    .querySelector(".pswp__button--prev")
                    .setAttribute("disabled", "disabled")
                : this.photoSwipeInstance.scrollWrap
                    .querySelector(".pswp__button--prev")
                    .removeAttribute("disabled"),
                this.photoSwipeInstance.getCurrentIndex() + 1 ===
                this.photoSwipeInstance.options.getNumItemsFn()
                  ? this.photoSwipeInstance.scrollWrap
                      .querySelector(".pswp__button--next")
                      .setAttribute("disabled", "disabled")
                  : this.photoSwipeInstance.scrollWrap
                      .querySelector(".pswp__button--next")
                      .removeAttribute("disabled");
            },
          },
          {
            key: "_onSingleTap",
            value: function (e) {
              if (e.detail && "mouse" !== e.detail.pointerType) {
                if (e.target.classList.contains("pswp__button")) return;
                e.target
                  .closest(".pswp")
                  .querySelector(".pswp__ui")
                  .classList.toggle("pswp__ui--hidden");
              } else
                e.target.classList.contains("pswp__img") &&
                  this.photoSwipeInstance.toggleDesktopZoom(
                    e.detail.releasePoint
                  );
            },
          },
          {
            key: "_onDoubleTap",
            value: function (e) {
              var t = this.photoSwipeInstance.currItem.initialZoomLevel;
              this.photoSwipeInstance.getZoomLevel() !== t
                ? this.photoSwipeInstance.zoomTo(t, e, 333)
                : this.photoSwipeInstance.zoomTo(t < 0.7 ? 1 : 1.33, e, 333);
            },
          },
          {
            key: "_onInitialZoomIn",
            value: function () {
              document
                .querySelector(".pswp__ui")
                .classList.remove("pswp__ui--hidden");
            },
          },
          {
            key: "_onInitialZoomOut",
            value: function () {
              document
                .querySelector(".pswp__ui")
                .classList.add("pswp__ui--hidden");
            },
          },
          {
            key: "_destroyPhotoSwipe",
            value: function () {
              this.delegateRoot.off("pswpTap"),
                (this.photoSwipeInstance = null);
            },
          },
        ]),
        t
      );
    })(),
    S = (function () {
      function t(i, n) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.delegateRoot = new domDelegate.Delegate(
            document.documentElement
          )),
          (this.stackProductImages = n),
          this._attachListeners();
        var o = document.createElement("link");
        (o.rel = "stylesheet"),
          (o.href =
            "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
          document.head.appendChild(o),
          window.Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this._setupModelViewerUI.bind(this),
            },
            {
              name: "shopify-xr",
              version: "1.0",
            },
          ]);
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {},
          },
          {
            key: "_attachListeners",
            value: function () {
              var e = this;
              this.element
                .querySelector("model-viewer")
                .addEventListener(
                  "shopify_model_viewer_ui_toggle_play",
                  function () {
                    e.element.dispatchEvent(
                      new CustomEvent("model:played", {
                        bubbles: !0,
                      })
                    );
                  }
                ),
                this.element
                  .querySelector("model-viewer")
                  .addEventListener(
                    "shopify_model_viewer_ui_toggle_pause",
                    function () {
                      e.element.dispatchEvent(
                        new CustomEvent("model:paused", {
                          bubbles: !0,
                        })
                      );
                    }
                  );
            },
          },
          {
            key: "hasBeenSelected",
            value: function () {
              c.matchesBreakpoint("supports-hover") && this.modelUi.play();
            },
          },
          {
            key: "hasBeenDeselected",
            value: function () {
              this.modelUi.pause();
            },
          },
          {
            key: "_setupModelViewerUI",
            value: function () {
              (this.modelElement = this.element.querySelector("model-viewer")),
                (this.modelUi = new window.Shopify.ModelViewerUI(
                  this.modelElement
                ));
            },
          },
        ]),
        t
      );
    })(),
    L = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          this.delegateElement.on(
            "click",
            ".spr-summary-actions-newreview",
            this._onNewReviewClicked.bind(this)
          ),
          (window.SPRCallbacks = {}),
          (window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this)),
          (window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this));
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.delegateElement.off();
            },
          },
          {
            key: "_updatePagination",
            value: function (e, t) {
              SPR.$(t).data("page", parseInt(t.getAttribute("data-page")) + 1);
            },
          },
          {
            key: "_onFormSuccess",
            value: function () {
              var e = this.element.querySelector(".spr-form-message-success");
              window.scrollTo(0, e.offsetTop - 45);
            },
          },
          {
            key: "_onReviewsLoad",
            value: function () {
              var e = this.element.querySelector(".spr-summary-actions"),
                t = e.querySelector(".spr-pagination-next"),
                i = this.element.querySelector(
                  ".spr-pagination .spr-pagination-next"
                );
              t && t.remove(), i && e.insertBefore(i, e.firstChild);
            },
          },
          {
            key: "_onNewReviewClicked",
            value: function (e, t) {
              (t.style.display = "none"),
                t.previousElementSibling &&
                  (t.previousElementSibling.style.display = "none");
            },
          },
        ]),
        t
      );
    })(),
    E = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "serialize",
            value: function (e) {
              function i(e, t) {
                var n = e.lastIndexOf("[");
                if (-1 === n) {
                  var o = {};
                  return (o[e] = t), o;
                }
                var s = e.substr(0, n),
                  a = {};
                return (a[e.substring(n + 1, e.length - 1)] = t), i(s, a);
              }
              for (var n = {}, o = 0, s = e.elements.length; o < s; o++) {
                var a = e.elements[o];
                if (
                  "" !== a.name &&
                  !a.disabled &&
                  a.name &&
                  !a.disabled &&
                  (a.checked ||
                    /select|textarea/i.test(a.nodeName) ||
                    /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                      a.type
                    ))
                ) {
                  var r = i(a.name, a.value);
                  n = t.extend(n, r);
                }
              }
              return n;
            },
          },
          {
            key: "extend",
            value: function () {
              for (
                var e = {},
                  i = 0,
                  n = function (i) {
                    for (var n in i)
                      i.hasOwnProperty(n) &&
                        ("[object Object]" ===
                        Object.prototype.toString.call(i[n])
                          ? (e[n] = t.extend(e[n], i[n]))
                          : (e[n] = i[n]));
                  };
                i < arguments.length;
                i++
              )
                n(arguments[i]);
              return e;
            },
          },
        ]),
        t
      );
    })(),
    I = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "formatMoney",
            value: function (e, t) {
              "string" == typeof e && (e = e.replace(".", ""));
              var i = /\{\{\s*(\w+)\s*\}\}/,
                n = t || "${{amount}}";

              function o(e, t) {
                return null == e || e != e ? t : e;
              }

              function s(e, t, i, n) {
                if (
                  ((t = o(t, 2)),
                  (i = o(i, ",")),
                  (n = o(n, ".")),
                  isNaN(e) || null == e)
                )
                  return 0;
                var s = (e = (e / 100).toFixed(t)).split(".");
                return (
                  s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
                  (s[1] ? n + s[1] : "")
                );
              }
              var a = "";
              switch (n.match(i)[1]) {
                case "amount":
                  a = s(e, 2);
                  break;
                case "amount_no_decimals":
                  a = s(e, 0);
                  break;
                case "amount_with_space_separator":
                  a = s(e, 2, " ", ".");
                  break;
                case "amount_no_decimals_with_comma_separator":
                  a = s(e, 0, ",", ".");
                  break;
                case "amount_no_decimals_with_space_separator":
                  a = s(e, 0, " ");
                  break;
                case "amount_with_comma_separator":
                  a = s(e, 2, ".", ",");
              }
              return -1 !== n.indexOf("with_comma_separator")
                ? n.replace(i, a).replace(",00", "")
                : n.replace(i, a).replace(".00", "");
            },
          },
        ]),
        t
      );
    })(),
    A = (function () {
      function t(i, n) {
        var o =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        e(this, t),
          (this.element = i),
          (this.parentProductVariants = n),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.activator =
            o.activator ||
            document.querySelector(
              '[aria-controls="'.concat(i.getAttribute("id"), '"]')
            )),
          (this.onValueChangedCallback = o.onValueChanged || function () {}),
          (this.isOpen = !1),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          (this.variantChoiceList = h.nodeListToArray(
            this.element.querySelectorAll(".VariantSelector__Choice")
          )),
          (this.variantCarousel = new d(
            this.element.querySelector(".VariantSelector__Carousel"),
            {
              onSelect: this._variantChanged.bind(this),
              onClick: this._variantSelected.bind(this),
            }
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.element.removeEventListener(
                "keyup",
                this._handleKeyboardListener
              ),
                this.delegateElement.off("click"),
                this.activator.removeEventListener(
                  "click",
                  this._toggleListener
                ),
                this.variantCarousel.destroy();
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.close() : this.open();
            },
          },
          {
            key: "open",
            value: function () {
              this.isOpen ||
                (this.element.setAttribute("aria-hidden", "false"),
                this.activator.setAttribute("aria-expanded", "true"),
                p.trapFocus(this.element, "variant-selector"),
                document.documentElement.classList.add("no-scroll"),
                this.element.setAttribute("style", ""),
                this.pageOverlayElement.classList.add("is-visible"),
                this.pageOverlayElement.addEventListener(
                  "click",
                  this._closeListener
                ),
                (this.isOpen = !0));
            },
          },
          {
            key: "close",
            value: function () {
              this.isOpen &&
                (this.element.setAttribute("aria-hidden", "true"),
                this.activator.setAttribute("aria-expanded", "false"),
                p.removeTrapFocus(this.element, "variant-selector"),
                document.documentElement.classList.remove("no-scroll"),
                this.pageOverlayElement.classList.remove("is-visible"),
                this.pageOverlayElement.removeEventListener(
                  "click",
                  this._closeListener
                ),
                (this.isOpen = !1));
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._handleKeyboardListener = this._handleKeyboard.bind(this)),
                (this._closeListener = this.close.bind(this)),
                (this._toggleListener = this.toggle.bind(this)),
                this.element.addEventListener(
                  "keyup",
                  this._handleKeyboardListener
                ),
                this.activator.addEventListener("click", this._toggleListener),
                this.delegateElement.on(
                  "click",
                  '[data-action="select-variant"]',
                  this._onVariantSelect.bind(this)
                ),
                this.parentProductVariants.delegateElement.on(
                  "variant:changed",
                  this._onVariantChanged.bind(this)
                );
            },
          },
          {
            key: "_variantChanged",
            value: function (e) {
              var t = this.variantChoiceList[e];
              t.classList.add("is-selected"),
                h.getSiblings(t, ".is-selected").forEach(function (e) {
                  return e.classList.remove("is-selected");
                });
            },
          },
          {
            key: "_variantSelected",
            value: function (e, t) {
              this.variantCarousel.getSelectedIndex() === t
                ? (this.onValueChangedCallback(
                    e.getAttribute("data-option-value"),
                    e,
                    this.activator
                  ),
                  this.close())
                : this.variantCarousel.selectCell(t);
            },
          },
          {
            key: "_onVariantChanged",
            value: function (e) {
              var t = this,
                i = e.detail.variant,
                n = this.element.querySelectorAll(
                  ".VariantSelector__ImageWrapper"
                ),
                o = !1;
              h.nodeListToArray(n).forEach(function (e) {
                var t =
                    parseInt(
                      e.parentElement.getAttribute("data-option-position")
                    ) - 1,
                  n = "";
                i.options.forEach(function (e, i) {
                  i !== t && (n += e);
                }),
                  e.getAttribute("data-variant-title") === n
                    ? (e.setAttribute("aria-hidden", "false"), (o = !0))
                    : e.setAttribute("aria-hidden", "true");
              }),
                o || n.children[0].setAttribute("aria-hidden", "false");
              var s = 0;
              h.nodeListToArray(
                this.element.querySelectorAll(".VariantSelector__ChoicePrice")
              ).forEach(function (e, n) {
                var o = parseInt(e.getAttribute("data-color-position")) - 1;
                t.parentProductVariants.productData.variants.forEach(function (
                  t
                ) {
                  var a = !0;
                  t.options.forEach(function (e, n) {
                    n !== o && t.options[n] !== i.options[n] && (a = !1);
                  }),
                    a &&
                      t.options[o] === i.options[o] &&
                      s++ === n &&
                      (e.innerHTML =
                        '<span class="Heading Text--subdued">'.concat(
                          I.formatMoney(t.price, window.theme.moneyFormat),
                          "</span>"
                        ));
                });
              });
            },
          },
          {
            key: "_onVariantSelect",
            value: function () {
              var e =
                this.variantCarousel.flickityInstance.selectedCell.element;
              this.onValueChangedCallback(
                e.getAttribute("data-option-value"),
                e,
                this.activator
              ),
                this.close();
            },
          },
          {
            key: "_handleKeyboard",
            value: function (e) {
              this.isOpen && 27 === e.keyCode && this.close();
            },
          },
        ]),
        t
      );
    })(),
    C = (function () {
      function t(i, n) {
        e(this, t), (this.element = i), (this.productTitle = n);
      }
      return (
        i(t, [
          {
            key: "updateWithVariant",
            value: function (e) {
              this.element &&
                (e
                  ? this._renderAvailabilitySection(e.id)
                  : (this.element.textContent = ""));
            },
          },
          {
            key: "_renderAvailabilitySection",
            value: function (e) {
              var t = this;
              this.element.innerHTML = "";
              var i = document.getElementById(
                "StoreAvailabilityModal-".concat(e)
              );
              return (
                i && i.remove(),
                fetch(
                  ""
                    .concat(window.routes.rootUrlWithoutSlash, "/variants/")
                    .concat(e, "?section_id=store-availability")
                ).then(function (i) {
                  return i.text().then(function (i) {
                    (t.element.innerHTML = i),
                      (t.element.innerHTML =
                        t.element.firstElementChild.innerHTML);
                    var n = t.element.querySelector(
                      ".store-availabilities-modal__product-title"
                    );
                    n && (n.textContent = t.productTitle);
                    var o = document.getElementById(
                      "StoreAvailabilityModal-".concat(e)
                    );
                    document.body.appendChild(o), new v(o);
                  });
                })
              );
            },
          },
        ]),
        t
      );
    })(),
    T = (function () {
      function t(i, n) {
        var o = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = n);
        var s = JSON.parse(
          this.element.querySelector("[data-product-json]").innerHTML
        );
        (this.productData = s.product),
          (this.variantsInventories = s.inventories || {}),
          (this.masterSelector = this.element.querySelector(
            "#product-select-".concat(this.productData.id)
          )),
          this.productData.variants.forEach(function (e) {
            e.id === s.selected_variant_id &&
              ((o.currentVariant = e),
              (o.option1 = e.option1),
              (o.option2 = e.option2),
              (o.option3 = e.option3));
          }),
          (this.storeAvailability = new C(
            this.element.querySelector(
              ".ProductMeta__StoreAvailabilityContainer"
            ),
            this.productData.title
          )),
          this.storeAvailability.updateWithVariant(this.currentVariant),
          this._attachListeners(),
          this._createSelectors();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.delegateElement.off("click"),
                this.formPopovers.forEach(function (e) {
                  return e.destroy();
                }),
                this.formVariantSelectors.forEach(function (e) {
                  return e.destroy();
                });
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                '[data-action="add-to-cart"]',
                this._addToCart.bind(this)
              ),
                this.delegateElement.on(
                  "click",
                  '[data-action="decrease-quantity"]',
                  this._decreaseQuantity.bind(this)
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="increase-quantity"]',
                  this._increaseQuantity.bind(this)
                ),
                this.delegateElement.on(
                  "change",
                  '[name="quantity"]',
                  this._validateQuantity.bind(this)
                ),
                this.delegateElement.on(
                  "change",
                  '.ProductForm__Option [type="radio"]',
                  this._onOptionChanged.bind(this)
                );
            },
          },
          {
            key: "_createSelectors",
            value: function () {
              var e = this;
              (this.formPopovers = []),
                (this.formVariantSelectors = []),
                h
                  .nodeListToArray(
                    this.element.querySelectorAll(".OptionSelector")
                  )
                  .forEach(function (t) {
                    var i = new g(t, {
                      preferredPosition: "left",
                      onValueChanged: e._onOptionChanged.bind(e),
                    });
                    e.formPopovers.push(i);
                  }),
                h
                  .nodeListToArray(
                    this.element.querySelectorAll(".VariantSelector")
                  )
                  .forEach(function (t) {
                    var i = new A(t, e, {
                      onValueChanged: e._onOptionChanged.bind(e),
                    });
                    e.formVariantSelectors.push(i);
                  });
            },
          },
          {
            key: "_onVariantChanged",
            value: function (e, t) {
              this._updateProductPrices(t, e),
                this._updateInventory(t, e),
                this._updateSku(t, e),
                this._updateUnitPrice(t, e),
                this._updateAddToCartButton(t, e),
                this.storeAvailability.updateWithVariant(t),
                this.element.dispatchEvent(
                  new CustomEvent("variant:changed", {
                    bubbles: !0,
                    detail: {
                      variant: t,
                      previousVariant: e,
                    },
                  })
                );
            },
          },
          {
            key: "_updateProductPrices",
            value: function (e, t) {
              var i = this.element.querySelector(".ProductMeta__PriceList");
              if (e) {
                if (
                  t &&
                  t.price === e.price &&
                  t.compare_at_price === e.compare_at_price
                )
                  return;
                (i.innerHTML = ""),
                  e.compare_at_price > e.price
                    ? ((i.innerHTML +=
                        '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>'.concat(
                          I.formatMoney(e.price, window.theme.moneyFormat),
                          "</span>"
                        )),
                      (i.innerHTML +=
                        '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>'.concat(
                          I.formatMoney(
                            e.compare_at_price,
                            window.theme.moneyFormat
                          ),
                          "</span>"
                        )))
                    : (i.innerHTML +=
                        '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>'.concat(
                          I.formatMoney(e.price, window.theme.moneyFormat),
                          "</span>"
                        )),
                  (i.style.display = "");
              } else i.style.display = "none";
            },
          },
          {
            key: "_updateInventory",
            value: function (e) {
              if (this.options.showInventoryQuantity) {
                var t = this.element.querySelector(".ProductForm__Inventory"),
                  i = e ? this.variantsInventories[e.id] : null;
                !e ||
                null === i.inventory_management ||
                i.inventory_quantity <= 0 ||
                (this.options.inventoryQuantityThreshold > 0 &&
                  i.inventory_quantity >
                    this.options.inventoryQuantityThreshold)
                  ? (t.style.display = "none")
                  : ((t.innerHTML = i.inventory_message),
                    (t.style.display = ""));
              }
            },
          },
          {
            key: "_updateSku",
            value: function (e) {
              if (this.options.showSku && e) {
                var t = this.element.querySelector(".ProductMeta__SkuNumber");
                t && e.sku && (t.innerText = e.sku);
              }
            },
          },
          {
            key: "_updateUnitPrice",
            value: function (e) {
              if (e) {
                var t = this.element.querySelector(
                  ".ProductMeta__UnitPriceMeasurement"
                );
                if (e.hasOwnProperty("unit_price")) {
                  (t.style.display = "block"),
                    (t.querySelector(".UnitPriceMeasurement__Price").innerHTML =
                      I.formatMoney(e.unit_price, window.theme.moneyFormat)),
                    (t.querySelector(
                      ".UnitPriceMeasurement__ReferenceUnit"
                    ).textContent = e.unit_price_measurement.reference_unit);
                  var i = t.querySelector(
                    ".UnitPriceMeasurement__ReferenceValue"
                  );
                  (i.textContent = e.unit_price_measurement.reference_value),
                    (i.style.display =
                      1 === e.unit_price_measurement.reference_value
                        ? "none"
                        : "inline");
                } else t.style.display = "none";
              }
            },
          },
          {
            key: "_updateAddToCartButton",
            value: function (e) {
              var t = this.element.querySelector(".ProductForm__AddToCart"),
                i = this.element.querySelector(".shopify-payment-button");
              t.classList.remove("Button--secondary"),
                t.classList.remove("Button--primary"),
                e
                  ? e.available
                    ? (t.removeAttribute("disabled"),
                      t.classList.add(
                        "true" === t.getAttribute("data-use-primary-button")
                          ? "Button--primary"
                          : "Button--secondary"
                      ),
                      t.setAttribute("data-action", "add-to-cart"),
                      void 0 === this.options.showPriceInButton ||
                      this.options.showPriceInButton
                        ? (t.innerHTML = "\n            <span>"
                            .concat(
                              window.languages.productFormAddToCart,
                              '</span>\n            <span class="Button__SeparatorDot"></span>\n            <span data-money-convertible>'
                            )
                            .concat(
                              I.formatMoney(e.price, window.theme.moneyFormat),
                              "</span>\n          "
                            ))
                        : (t.innerHTML = "<span>".concat(
                            window.languages.productFormAddToCart,
                            "</span>"
                          )))
                    : (t.setAttribute("disabled", "disabled"),
                      t.classList.add("Button--secondary"),
                      t.removeAttribute("data-action"),
                      (t.innerHTML = window.languages.productFormSoldOut))
                  : (t.setAttribute("disabled", "disabled"),
                    t.removeAttribute("data-action"),
                    t.classList.add("Button--secondary"),
                    (t.innerHTML = window.languages.productFormUnavailable)),
                this.options.showPaymentButton &&
                  i &&
                  (e && e.available
                    ? (i.style.display = "block")
                    : (i.style.display = "none"));
            },
          },
          {
            key: "_onOptionChanged",
            value: function (e, t, i) {
              if (i)
                (this["option" + t.getAttribute("data-option-position")] = e),
                  (i.querySelector(".ProductForm__SelectedValue").innerHTML =
                    e);
              else {
                this["option" + t.getAttribute("data-option-position")] =
                  t.value;
                var n = t
                  .closest(".ProductForm__Option")
                  .querySelector(".ProductForm__SelectedValue");
                n && (n.innerHTML = t.value);
              }
              var o = this.currentVariant;
              (this.currentVariant = this._getCurrentVariantFromOptions()),
                this._onVariantChanged(o, this.currentVariant),
                this.currentVariant &&
                  (this.options.enableHistoryState &&
                    this._updateHistoryState(this.currentVariant),
                  this.masterSelector
                    .querySelector("[selected]")
                    .removeAttribute("selected"),
                  this.masterSelector
                    .querySelector(
                      '[value="'.concat(this.currentVariant.id, '"]')
                    )
                    .setAttribute("selected", "selected"),
                  this.masterSelector.dispatchEvent(
                    new Event("change", {
                      bubbles: !0,
                    })
                  ));
            },
          },
          {
            key: "_getCurrentVariantFromOptions",
            value: function () {
              var e = this,
                t = !1;
              return (
                this.productData.variants.forEach(function (i) {
                  i.option1 === e.option1 &&
                    i.option2 === e.option2 &&
                    i.option3 === e.option3 &&
                    (t = i);
                }),
                t || null
              );
            },
          },
          {
            key: "_updateHistoryState",
            value: function (e) {
              if (history.replaceState) {
                var t = ""
                  .concat(window.location.protocol, "//")
                  .concat(window.location.host)
                  .concat(window.location.pathname, "?variant=")
                  .concat(e.id);
                window.history.replaceState(
                  {
                    path: t,
                  },
                  "",
                  t
                );
              }
            },
          },
          {
            key: "_addToCart",
            value: function (e) {
              var t = this;
              if (this.options.useAjaxCart) {
                e.preventDefault();
                var i = this.element.querySelector(".ProductForm__AddToCart");
                i.setAttribute("disabled", "disabled"),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  );
                var n = this.element.querySelector('form[action*="/cart/add"]');
                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                  body: JSON.stringify(E.serialize(n)),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                }).then(function (e) {
                  document.dispatchEvent(new CustomEvent("theme:loading:end"));
                  var o = n.querySelector('[name="quantity"]');
                  e.ok
                    ? (i.removeAttribute("disabled"),
                      t.element.dispatchEvent(
                        new CustomEvent("product:added", {
                          bubbles: !0,
                          detail: {
                            variant: t.currentVariant,
                            quantity: o ? parseInt(o.value) : 1,
                          },
                        })
                      ))
                    : e.json().then(function (e) {
                        var t = document.createElement("span");
                        (t.className = "ProductForm__Error Alert Alert--error"),
                          (t.innerHTML = e.description),
                          i.removeAttribute("disabled"),
                          i.insertAdjacentElement("afterend", t),
                          setTimeout(function () {
                            t.remove();
                          }, 2500);
                      });
                }),
                  e.preventDefault();
              }
            },
          },
          {
            key: "_decreaseQuantity",
            value: function (e, t) {
              t.nextElementSibling.value = Math.max(
                parseInt(t.nextElementSibling.value) - 1,
                1
              );
            },
          },
          {
            key: "_increaseQuantity",
            value: function (e, t) {
              t.previousElementSibling.value =
                parseInt(t.previousElementSibling.value) + 1;
            },
          },
          {
            key: "_validateQuantity",
            value: function (e, t) {
              t.value = Math.max(parseInt(t.value) || 1, 1);
            },
          },
        ]),
        t
      );
    })(),
    P = (function () {
      function t(i, n, o) {
        switch (
          (e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.stackProductImages = n),
          (this.enableVideoLooping = o),
          (this.player = null),
          this.element.getAttribute("data-media-type"))
        ) {
          case "video":
            var s = document.createElement("link");
            (s.rel = "stylesheet"),
              (s.href =
                "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
              document.head.appendChild(s),
              window.Shopify.loadFeatures([
                {
                  name: "video-ui",
                  version: "1.0",
                  onLoad: this._setupHtml5Video.bind(this),
                },
              ]);
            break;
          case "external_video":
            this._setupExternalVideo();
        }
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.player && this.player.destroy();
            },
          },
          {
            key: "hasBeenSelected",
            value: function () {
              c.matchesBreakpoint("supports-hover") && this.play();
            },
          },
          {
            key: "hasBeenDeselected",
            value: function () {
              this.pause();
            },
          },
          {
            key: "play",
            value: function () {
              switch (this.element.getAttribute("data-media-type")) {
                case "video":
                  this.player.play();
                  break;
                case "external_video":
                  this.player.playVideo();
              }
            },
          },
          {
            key: "pause",
            value: function () {
              switch (this.element.getAttribute("data-media-type")) {
                case "video":
                  this.player.pause();
                  break;
                case "external_video":
                  this.player.pauseVideo();
              }
            },
          },
          {
            key: "_setupHtml5Video",
            value: function () {
              var e = this;
              (this.player = new Shopify.Plyr(
                this.element.querySelector("video"),
                {
                  controls: [
                    "play",
                    "progress",
                    "mute",
                    "volume",
                    "play-large",
                    "fullscreen",
                  ],
                  loop: {
                    active: this.enableVideoLooping,
                  },
                  hideControlsOnPause: !0,
                  clickToPlay: !0,
                  iconUrl:
                    "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                  tooltips: {
                    controls: !1,
                    seek: !0,
                  },
                }
              )),
                this.player.on("play", function () {
                  e.element.dispatchEvent(
                    new CustomEvent("video:played", {
                      bubbles: !0,
                    })
                  );
                }),
                this.player.on("pause", function () {
                  e.element.dispatchEvent(
                    new CustomEvent("video:paused", {
                      bubbles: !0,
                    })
                  );
                });
            },
          },
          {
            key: "_setupExternalVideo",
            value: function () {
              "youtube" === this.element.getAttribute("data-video-host") &&
                this._loadYouTubeScript().then(
                  this._setupYouTubePlayer.bind(this)
                );
            },
          },
          {
            key: "_setupYouTubePlayer",
            value: function () {
              var e = this,
                t = setInterval(function () {
                  void 0 !== window.YT &&
                    void 0 !== window.YT.Player &&
                    ((e.player = new YT.Player(
                      e.element.querySelector("iframe"),
                      {
                        videoId: e.element.getAttribute("data-video-id"),
                        events: {
                          onStateChange: function (t) {
                            t.data === window.YT.PlayerState.PLAYING
                              ? e.element.dispatchEvent(
                                  new CustomEvent("video:played", {
                                    bubbles: !0,
                                  })
                                )
                              : t.data === YT.PlayerState.PAUSED &&
                                e.element.dispatchEvent(
                                  new CustomEvent("video:paused", {
                                    bubbles: !0,
                                  })
                                ),
                              t.data === window.YT.PlayerState.ENDED &&
                                e.enableVideoLooping &&
                                t.target.seekTo(0);
                          },
                        },
                      }
                    )),
                    clearInterval(t));
                }, 50);
            },
          },
          {
            key: "_loadYouTubeScript",
            value: function () {
              return new Promise(function (e, t) {
                var i = document.createElement("script");
                document.body.appendChild(i),
                  (i.onload = e),
                  (i.onerror = t),
                  (i.async = !0),
                  (i.src = "//www.youtube.com/iframe_api");
              });
            },
          },
        ]),
        t
      );
    })(),
    x = (function () {
      function t(i, n, o) {
        var s = this;
        e(this, t),
          (this.container = i),
          (this.targets = []),
          (this.targetIndices = {}),
          (this.indicesInViewPort = []),
          (this.observer = new IntersectionObserver(
            this._onIntersectionChange.bind(this),
            o
          )),
          n.forEach(function (e, t) {
            s.targets.push(e),
              (s.targetIndices[e.id] = t),
              s.observer.observe(e);
          });
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.observer.disconnect();
            },
          },
          {
            key: "_onIntersectionChange",
            value: function (e) {
              for (
                var t = this.indicesInViewPort[0] || 0, i = e.length - 1;
                i >= 0;
                i--
              )
                this._updateIndicesInViewPort(e[i], t);
              if (
                ((this.indicesInViewPort = this.indicesInViewPort.filter(
                  function (e, t, i) {
                    return i.indexOf(e) === t;
                  }
                )),
                0 !== this.indicesInViewPort.length &&
                  t !== this.indicesInViewPort[0])
              ) {
                var n = new CustomEvent("scrollspy:target:changed", {
                  detail: {
                    newTarget: this.targets[this.indicesInViewPort[0]],
                    oldTarget: this.targets[t],
                  },
                });
                this.container.dispatchEvent(n);
              }
            },
          },
          {
            key: "_updateIndicesInViewPort",
            value: function (e, t) {
              var i = this.targetIndices[e.target.id];
              if (0 === e.intersectionRatio) {
                var n = this.indicesInViewPort.indexOf(i);
                -1 !== n && this.indicesInViewPort.splice(n, 1);
              } else
                i < t
                  ? this.indicesInViewPort.unshift(i)
                  : i >
                    this.indicesInViewPort[this.indicesInViewPort.length - 1]
                  ? this.indicesInViewPort.push(i)
                  : (this.indicesInViewPort.push(i),
                    this.indicesInViewPort.sort());
            },
          },
        ]),
        t
      );
    })(),
    q = (function () {
      function t() {
        e(this, t),
          (this.documentDelegate = new domDelegate.Delegate(document.body)),
          (this.searchElement = document.getElementById("Search")),
          (this.searchInputElement =
            this.searchElement.querySelector('[name="q"]')),
          (this.searchResultsElement =
            this.searchElement.querySelector(".Search__Results")),
          (this.queryMap = {}),
          (this.isOpen = !1),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.searchInputElement.removeEventListener(
                "keydown",
                this._preventSubmissionListener
              ),
                this.searchInputElement.removeEventListener(
                  "input",
                  this._onInputListener
                ),
                this.documentDelegate.off();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._preventSubmissionListener =
                this._preventSubmission.bind(this)),
                (this._onInputListener = this._debounce(
                  this._onInput.bind(this),
                  250
                )),
                this.searchInputElement.addEventListener(
                  "keydown",
                  this._preventSubmissionListener
                ),
                this.searchInputElement.addEventListener(
                  "input",
                  this._onInputListener
                ),
                this.documentDelegate.on(
                  "click",
                  '[data-action="toggle-search"]',
                  this._toggleSearch.bind(this)
                ),
                this.documentDelegate.on(
                  "click",
                  '[data-action="open-search"]',
                  this._openSearch.bind(this)
                ),
                this.documentDelegate.on(
                  "click",
                  '[data-action="close-search"]',
                  this._closeSearch.bind(this)
                ),
                this.documentDelegate.on(
                  "search:close",
                  this._closeSearch.bind(this)
                );
            },
          },
          {
            key: "_toggleSearch",
            value: function (e) {
              this.isOpen ? this._closeSearch(e) : this._openSearch(e),
                e.preventDefault();
            },
          },
          {
            key: "_openSearch",
            value: function () {
              var e = this;
              this.searchElement.setAttribute("aria-hidden", "false"),
                document.documentElement.classList.add("no-scroll"),
                p.trapFocus(
                  this.searchElement,
                  "search",
                  this.searchElement.querySelector('[name="q"]')
                );
              this.searchElement.addEventListener(
                "transitionend",
                function t() {
                  e.searchInputElement.focus(),
                    e.searchElement.removeEventListener("transitionend", t);
                }
              ),
                (this.isOpen = !0),
                this.pageOverlayElement.classList.add("is-visible"),
                (document.querySelector(
                  "#shopify-section-header"
                ).style.zIndex = 10);
            },
          },
          {
            key: "_closeSearch",
            value: function () {
              var e = this;
              this.searchElement.setAttribute("aria-hidden", "true"),
                document.documentElement.classList.remove("no-scroll"),
                p.removeTrapFocus(this.searchElement, "search"),
                (this.isOpen = !1);
              this.pageOverlayElement.addEventListener(
                "transitionend",
                function t(i) {
                  "visibility" === i.propertyName &&
                    ((document.querySelector(
                      "#shopify-section-header"
                    ).style.zIndex = ""),
                    e.pageOverlayElement.removeEventListener(
                      "transitionend",
                      t
                    ));
                }
              ),
                this.pageOverlayElement.classList.remove("is-visible");
            },
          },
          {
            key: "_preventSubmission",
            value: function (e) {
              13 === e.keyCode &&
                "product" !== window.theme.searchMode &&
                e.preventDefault();
            },
          },
          {
            key: "_onInput",
            value: function (e) {
              var t = this;
              if (13 !== e.keyCode)
                if (
                  ((this.lastInputValue = e.target.value),
                  "" !== this.lastInputValue)
                ) {
                  var i = {
                      method: "GET",
                      credentials: "same-origin",
                    },
                    n = [
                      fetch(
                        ""
                          .concat(
                            window.routes.searchUrl,
                            "?section_id=predictive-search&q="
                          )
                          .concat(
                            encodeURIComponent(this.lastInputValue),
                            "*&type=product"
                          ),
                        i
                      ),
                    ];
                  "product" !== window.theme.searchMode &&
                    n.push(
                      fetch(
                        ""
                          .concat(
                            window.routes.searchUrl,
                            "?section_id=predictive-search&q="
                          )
                          .concat(
                            encodeURIComponent(this.lastInputValue),
                            "*&type="
                          )
                          .concat(
                            window.theme.searchMode.replace("product,", "")
                          ),
                        i
                      )
                    ),
                    (this.queryMap[this.lastInputValue] = !0),
                    document.dispatchEvent(
                      new CustomEvent("theme:loading:start")
                    ),
                    Promise.all(n).then(function (i) {
                      t.lastInputValue === e.target.value &&
                        (delete t.queryMap[e.target.value],
                        Promise.all(
                          i.map(function (e) {
                            return e.text();
                          })
                        ).then(function (e) {
                          "product" === window.theme.searchMode
                            ? (t.searchResultsElement.innerHTML = e[0])
                            : (t.searchResultsElement.innerHTML =
                                '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">'
                                  .concat(
                                    e[0],
                                    '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">'
                                  )
                                  .concat(e[1], "</div>\n            </div>")),
                            t.searchResultsElement.setAttribute(
                              "aria-hidden",
                              "false"
                            );
                        }),
                        document.dispatchEvent(
                          new CustomEvent("theme:loading:end")
                        ));
                    });
                } else this._resetSearch();
            },
          },
          {
            key: "_resetSearch",
            value: function () {
              "product" === window.theme.searchMode
                ? (this.searchResultsElement.innerHTML = "")
                : (this.searchResultsElement.innerHTML =
                    '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>'),
                this.searchResultsElement.setAttribute("aria-hidden", "true"),
                document.dispatchEvent(new CustomEvent("theme:loading:end"));
            },
          },
          {
            key: "_debounce",
            value: function (e, t) {
              var i = this,
                n = null;
              return function () {
                for (
                  var o = arguments.length, s = new Array(o), a = 0;
                  a < o;
                  a++
                )
                  s[a] = arguments[a];
                clearTimeout(n),
                  (n = setTimeout(function () {
                    e.apply(i, s);
                  }, t));
              };
            },
          },
        ]),
        t
      );
    })(),
    M = (function () {
      function t(i, n) {
        e(this, t),
          (this.countrySelect = i),
          (this.provinceSelect = n),
          this.countrySelect &&
            this.provinceSelect &&
            (this._attachListeners(), this._initSelectors());
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              this.countrySelect &&
                this.countrySelect.removeEventListener(
                  "change",
                  this._onCountryChangedListener
                );
            },
          },
          {
            key: "_initSelectors",
            value: function () {
              var e = this.countrySelect.getAttribute("data-default");
              if (e) {
                for (var t = 0; t !== this.countrySelect.options.length; ++t)
                  if (this.countrySelect.options[t].text === e) {
                    this.countrySelect.selectedIndex = t;
                    break;
                  }
              } else this.countrySelect.selectedIndex = 0;
              var i = new Event("change", {
                bubbles: !0,
              });
              this.countrySelect.dispatchEvent(i);
              var n = this.provinceSelect.getAttribute("data-default");
              if (n)
                for (var o = 0; o !== this.provinceSelect.options.length; ++o)
                  if (this.provinceSelect.options[o].text === n) {
                    this.provinceSelect.selectedIndex = o;
                    break;
                  }
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._onCountryChangedListener =
                this._onCountryChanged.bind(this)),
                this.countrySelect.addEventListener(
                  "change",
                  this._onCountryChangedListener
                );
            },
          },
          {
            key: "_onCountryChanged",
            value: function () {
              var e = this,
                t =
                  this.countrySelect.options[this.countrySelect.selectedIndex],
                i = JSON.parse(t.getAttribute("data-provinces") || "[]");
              (this.provinceSelect.innerHTML = ""),
                0 !== i.length
                  ? (i.forEach(function (t) {
                      e.provinceSelect.options.add(new Option(t[1], t[0]));
                    }),
                    (this.provinceSelect.parentNode.style.display = "block"))
                  : (this.provinceSelect.parentNode.style.display = "none");
            },
          },
        ]),
        t
      );
    })(),
    O = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.countrySelector = new M(
            this.element.querySelector('[name="country"]'),
            this.element.querySelector('[name="province"]')
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.delegateElement.off("click"), this.countrySelector.destroy();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                ".ShippingEstimator__Submit",
                this._fetchRates.bind(this)
              );
            },
          },
          {
            key: "_fetchRates",
            value: function () {
              var e = this,
                t = this.element.querySelector('[name="country"]').value,
                i = this.element.querySelector('[name="province"]').value,
                n = this.element.querySelector('[name="zip"]').value;
              document.dispatchEvent(new CustomEvent("theme:loading:start")),
                fetch(
                  ""
                    .concat(
                      window.routes.cartUrl,
                      "/shipping_rates.json?shipping_address[zip]="
                    )
                    .concat(n, "&shipping_address[country]=")
                    .concat(t, "&shipping_address[province]=")
                    .concat(i),
                  {
                    credentials: "same-origin",
                    method: "GET",
                  }
                ).then(function (t) {
                  t.json().then(function (i) {
                    document.dispatchEvent(
                      new CustomEvent("theme:loading:end")
                    );
                    var n = e.element.querySelector(
                        ".ShippingEstimator__Results"
                      ),
                      o = e.element.querySelector(".ShippingEstimator__Error");
                    if (t.ok) {
                      var s = i.shipping_rates;
                      if (0 === s.length)
                        n.innerHTML = "<p>".concat(
                          window.languages.shippingEstimatorNoResults,
                          "</p>"
                        );
                      else {
                        var a = "";
                        1 === s.length
                          ? (a += "<p>".concat(
                              window.languages.shippingEstimatorOneResult,
                              "</p><ul>"
                            ))
                          : (a += "<p>".concat(
                              window.languages.shippingEstimatorMoreResults.replace(
                                "{{count}}",
                                s.length
                              ),
                              "</p><ul>"
                            )),
                          s.forEach(function (e) {
                            a += "<li>"
                              .concat(e.name, ": ")
                              .concat(
                                I.formatMoney(
                                  e.price,
                                  window.theme.moneyFormat
                                ),
                                "</li>"
                              );
                          }),
                          (a += "</ul>"),
                          (n.firstElementChild.innerHTML = a);
                      }
                      TweenLite.fromTo(
                        n.firstElementChild,
                        0.6,
                        {
                          autoAlpha: 0,
                          y: -15,
                        },
                        {
                          autoAlpha: 1,
                          y: 0,
                          delay: 0.35,
                        }
                      ),
                        (o.style.display = "none"),
                        (n.style.display = "block"),
                        u.slideDown(n);
                    } else {
                      var r = "";
                      Object.keys(i).forEach(function (e) {
                        r += '<li class="Alert__ErrorItem">'
                          .concat(e, " ")
                          .concat(i[e], "</li>");
                      }),
                        (o.innerHTML = '<ul class="Alert__ErrorList">'.concat(
                          r,
                          "</ul>"
                        )),
                        (n.style.display = "none"),
                        (o.style.display = "block");
                    }
                  });
                });
            },
          },
        ]),
        t
      );
    })(),
    D = function t() {
      var i = this;
      e(this, t),
        (this.countrySelectors = []),
        h
          .nodeListToArray(document.querySelectorAll(".Modal--address"))
          .forEach(function (e) {
            i.countrySelectors.push(
              new M(
                e.querySelector('[name="address[country]"]'),
                e.querySelector('[name="address[province]"]')
              )
            );
          });
    },
    H = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          window.theme.showElementStaggering &&
            ((this.timeline = new TimelineLite({
              delay: window.theme.showPageTransition ? 0.5 : 0,
            })),
            (this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this)
            )),
            h
              .nodeListToArray(this.element.querySelectorAll(".ArticleItem"))
              .forEach(function (e) {
                n.intersectionObserver.observe(e);
              }));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              window.theme.showElementStaggering &&
                (this.intersectionObserver.disconnect(), this.timeline.kill());
            },
          },
          {
            key: "_reveal",
            value: function (e) {
              var t = this,
                i = [];
              e.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (i.push(e.target),
                  t.intersectionObserver.unobserve(e.target));
              }),
                0 !== i.length &&
                  this.timeline.staggerFromTo(
                    i,
                    0.45,
                    {
                      autoAlpha: 0,
                      y: 30,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                    },
                    0.2
                  );
            },
          },
        ]),
        t
      );
    })(),
    B = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.toolbarElement = this.element.querySelector(".ArticleToolbar")),
          (this.articleNavElement = this.element.querySelector(".ArticleNav")),
          this.element.querySelector(".Article__Image") &&
            window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)")
              .matches &&
            (this.parallaxInstance = new Rellax(".Article__Image", {
              speed: -7,
              center: !1,
              round: !0,
            })),
          window.theme.showElementStaggering &&
            ((this.timeline = new TimelineLite({
              delay: window.theme.showPageTransition ? 0.5 : 0,
            })),
            (this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this)
            )),
            h
              .nodeListToArray(this.element.querySelectorAll(".ArticleItem"))
              .forEach(function (e) {
                n.intersectionObserver.observe(e);
              })),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.parallaxInstance && this.parallaxInstance.destroy(),
                window.theme.showElementStaggering &&
                  (this.intersectionObserver.disconnect(),
                  this.timeline.kill()),
                window.removeEventListener("scroll", this._onScrollListener);
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._onScrollListener =
                this._checkToolbarVisibility.bind(this)),
                window.addEventListener("scroll", this._onScrollListener);
            },
          },
          {
            key: "_checkToolbarVisibility",
            value: function () {
              var e = this,
                t = 0,
                i = 0,
                n = 0,
                o = 0,
                s = document.querySelector(".Header");
              fastdom.measure(function () {
                (t = window.pageYOffset),
                  (i = s.offsetHeight),
                  (o = parseInt(
                    window
                      .getComputedStyle(document.body)
                      .getPropertyValue("--use-sticky-header") || 0
                  )),
                  e.articleNavElement &&
                    (n =
                      e.articleNavElement.offsetTop +
                      e.articleNavElement.clientHeight -
                      i);
              }),
                fastdom.mutate(function () {
                  (e.toolbarElement.style.top = o ? i + "px" : null),
                    e.articleNavElement
                      ? t > 150 && e.articleNavElement && t < n
                        ? e.toolbarElement.classList.add("is-visible")
                        : e.toolbarElement.classList.remove("is-visible")
                      : t > 150
                      ? e.toolbarElement.classList.add("is-visible")
                      : e.toolbarElement.classList.remove("is-visible");
                });
            },
          },
          {
            key: "_reveal",
            value: function (e) {
              var t = this,
                i = [];
              e.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (i.push(e.target),
                  t.intersectionObserver.unobserve(e.target));
              }),
                0 !== i.length &&
                  this.timeline.staggerFromTo(
                    i,
                    0.45,
                    {
                      autoAlpha: 0,
                      y: 30,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                    },
                    0.2
                  );
            },
          },
        ]),
        t
      );
    })(),
    N = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.documentDelegate = new domDelegate.Delegate(
            document.documentElement
          )),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          (this.itemCount = this.options.itemCount),
          (this.isCartNoteOpen = !1),
          this.options.drawer &&
            (this.sidebarDrawer = new v(this.element, {
              onClose: this._onDrawerClosed.bind(this),
            })),
          this.options.hasShippingEstimator &&
            (this.shippingEstimator = new O(
              this.element.querySelector(".ShippingEstimator")
            )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.options.hasShippingEstimator &&
                this.shippingEstimator.destroy(),
                this.delegateElement.off(),
                document.removeEventListener(
                  "product:added",
                  this._onProductAddedListener
                );
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._onProductAddedListener = this._onProductAdded.bind(this)),
                this.delegateElement.on(
                  "change",
                  "#cart-note",
                  this._updateCartNote.bind(this)
                ),
                "page" !== this.options.type
                  ? (this.delegateElement.on(
                      "click",
                      '[data-action="update-item-quantity"], [data-action="remove-item"]',
                      this._updateItemQuantity.bind(this)
                    ),
                    this.delegateElement.on(
                      "change",
                      ".QuantitySelector__CurrentQuantity",
                      this._updateItemQuantity.bind(this)
                    ))
                  : this.delegateElement.on(
                      "change",
                      ".QuantitySelector__CurrentQuantity",
                      this._reloadPageWithQuantity.bind(this)
                    ),
                this.options.drawer &&
                  this.delegateElement.on(
                    "click",
                    '[data-action="toggle-cart-note"]',
                    this._toggleCartNote.bind(this)
                  ),
                document.addEventListener(
                  "product:added",
                  this._onProductAddedListener
                ),
                this.documentDelegate.on(
                  "cart:refresh",
                  this._rerenderCart.bind(this, !1)
                );
            },
          },
          {
            key: "_updateCartNote",
            value: function (e, t) {
              fetch("".concat(window.routes.cartUrl, "/update.js"), {
                body: JSON.stringify({
                  note: t.value,
                }),
                credentials: "same-origin",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              });
            },
          },
          {
            key: "_toggleCartNote",
            value: function () {
              var e = this,
                t = this.element.querySelector(".Cart__OffscreenNoteContainer"),
                i = this.element.querySelector("#cart-note");
              if (
                (this.element.classList.toggle("has-note-open"),
                (this.element.querySelector(".Cart__NoteButton").innerHTML =
                  "" !== i.value
                    ? window.languages.cartEditNote
                    : window.languages.cartAddNote),
                t.setAttribute(
                  "aria-hidden",
                  "true" === t.getAttribute("aria-hidden") ? "false" : "true"
                ),
                (this.isCartNoteOpen =
                  "false" === t.getAttribute("aria-hidden")),
                this.element.classList.contains("has-note-open"))
              ) {
                t.addEventListener("transitionend", function i() {
                  e.element.querySelector("#cart-note").focus(),
                    t.removeEventListener("transitionend", i);
                });
              }
            },
          },
          {
            key: "_updateItemQuantity",
            value: function (e, t) {
              var i = this;
              document.dispatchEvent(new CustomEvent("theme:loading:start"));
              var n = null,
                o = null;
              0 ===
                (n =
                  "INPUT" === t.tagName
                    ? parseInt(Math.max(parseInt(t.value) || 1, 1))
                    : parseInt(t.getAttribute("data-quantity"))) &&
                (o = t.closest(".CartItemWrapper")),
                fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                  body: JSON.stringify({
                    line: t.getAttribute("data-line"),
                    quantity: n,
                  }),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                }).then(function (e) {
                  e.json().then(function (e) {
                    (i.itemCount = e.item_count),
                      i._rerenderCart(o),
                      document.dispatchEvent(
                        new CustomEvent("theme:loading:end")
                      );
                  });
                }),
                e.preventDefault();
            },
          },
          {
            key: "_reloadPageWithQuantity",
            value: function (e, t) {
              window.location.href = ""
                .concat(window.routes.cartChangeUrl, "?quantity=")
                .concat(parseInt(t.value), "&line=")
                .concat(t.getAttribute("data-line"));
            },
          },
          {
            key: "_onProductAdded",
            value: function (e) {
              var t = this;
              (this.itemCount += e.detail.quantity),
                this._rerenderCart().then(function () {
                  t.sidebarDrawer.open();
                });
            },
          },
          {
            key: "_onDrawerClosed",
            value: function () {
              this.isCartNoteOpen && this._toggleCartNote();
            },
          },
          {
            key: "_rerenderCart",
            value: function (e) {
              var t = this;
              return fetch(
                ""
                  .concat(window.routes.cartUrl, "?section_id=")
                  .concat(
                    this.options.drawer && "cart" !== window.theme.pageType
                      ? "mini-cart"
                      : "main-cart",
                    "&timestamp="
                  )
                  .concat(Date.now()),
                {
                  credentials: "same-origin",
                  method: "GET",
                }
              ).then(function (i) {
                if (t.options.drawer && e) {
                  var n = new TimelineLite({
                    onComplete: function () {
                      i.text().then(function (e) {
                        t._replaceContent(e);
                      });
                    },
                  });
                  n.to(
                    e,
                    0.5,
                    {
                      height: 0,
                      opacity: 0,
                      ease: Cubic.easeOut,
                    },
                    0
                  ),
                    0 === t.itemCount &&
                      n.to(
                        t.element.querySelector(".Drawer__Footer"),
                        0.5,
                        {
                          y: "100%",
                          transition: "none",
                          ease: Cubic.easeInOut,
                        },
                        0
                      );
                } else
                  i.text().then(function (e) {
                    t._replaceContent(e);
                  });
              });
            },
          },
          {
            key: "_replaceContent",
            value: function (e) {
              var t = this,
                i = document.createElement("div");
              i.innerHTML = e;
              var n = this.element.querySelector(".Cart").parentNode;
              if (this.options.drawer && "cart" !== window.theme.pageType) {
                var o = this.element.querySelector(".Drawer__Main").scrollTop;
                n.replaceChild(
                  i.querySelector(".Cart"),
                  this.element.querySelector(".Cart")
                ),
                  (this.element.querySelector(".Drawer__Main").scrollTop = o);
              } else
                0 === this.itemCount
                  ? (this.element.innerHTML =
                      i.querySelector(
                        ".shopify-section"
                      ).firstElementChild.innerHTML)
                  : (n.replaceChild(
                      i.querySelector(".Cart"),
                      this.element.querySelector(".Cart")
                    ),
                    this.element.querySelector(".PageHeader")
                      ? (this.element.querySelector(".PageHeader").innerHTML =
                          i.querySelector(".PageHeader").innerHTML)
                      : null);
              var s = JSON.parse(
                  i
                    .querySelector('[data-section-type="cart"]')
                    .getAttribute("data-section-settings")
                ),
                a = h.nodeListToArray(
                  document.querySelectorAll(".Header__CartDot")
                ),
                r = h.nodeListToArray(
                  document.querySelectorAll(".Header__CartCount")
                );
              (this.itemCount = s.itemCount),
                a.forEach(function (e) {
                  0 === t.itemCount
                    ? e.classList.remove("is-visible")
                    : e.classList.add("is-visible");
                }),
                r.forEach(function (e) {
                  e.textContent = t.itemCount;
                });
            },
          },
        ]),
        t
      );
    })(),
    V = (function () {
      function t(i) {
        e(this, t), (this.element = i);
        var n = this.element.querySelector("[data-flickity-config]");
        n && (this.carousel = new d(n));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.carousel && this.carousel.destroy();
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              this.carousel &&
                this.carousel.selectCell(
                  e.target.getAttribute("data-slide-index"),
                  !0,
                  !e.detail.load
                );
            },
          },
          {
            key: "onBlockDeselect",
            value: function () {
              this.carousel && this.carousel.unpausePlayer();
            },
          },
        ]),
        t
      );
    })(),
    R = (function () {
      function t(i) {
        e(this, t),
          i &&
            ((this.element = i),
            (this.lastKnownY = window.scrollY),
            (this.currentTop = 0),
            (this.initialTopOffset = parseInt(
              window.getComputedStyle(this.element).top
            )),
            this._attachListeners());
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function () {
              window.removeEventListener("scroll", this._checkPositionListener);
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._checkPositionListener = this._checkPosition.bind(this)),
                window.addEventListener("scroll", this._checkPositionListener);
            },
          },
          {
            key: "_checkPosition",
            value: function () {
              var e = this;
              fastdom.measure(function () {
                var t =
                    e.element.getBoundingClientRect().top +
                    window.scrollY -
                    e.element.offsetTop +
                    e.initialTopOffset,
                  i = e.element.clientHeight - window.innerHeight;
                window.scrollY < e.lastKnownY
                  ? (e.currentTop -= window.scrollY - e.lastKnownY)
                  : (e.currentTop += e.lastKnownY - window.scrollY),
                  (e.currentTop = Math.min(
                    Math.max(e.currentTop, -i),
                    t,
                    e.initialTopOffset
                  )),
                  (e.lastKnownY = window.scrollY);
              }),
                fastdom.mutate(function () {
                  e.element.style.top = "".concat(e.currentTop, "px");
                });
            },
          },
        ]),
        t
      );
    })(),
    F = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.toolbarElement =
            this.element.querySelector(".CollectionToolbar")),
          (this.collectionInnerElement = this.element.querySelector(
            ".CollectionInner__Products"
          )),
          (this.settings = JSON.parse(
            this.element.getAttribute("data-section-settings")
          ));
        var n = document.getElementById("collection-sort-popover");
        n &&
          (this.sortPopover = new g(n, {
            onValueChanged: this._sortByChanged.bind(this),
          }));
        var o = document.getElementById("collection-filter-drawer");
        o && (this.filterDrawer = new v(o)),
          "sidebar" === this.settings.filterPosition &&
            (this.filterInnerSidebarScroller = new R(
              this.element.querySelector(".CollectionInner__Sidebar")
            )),
          this.element.querySelector(".PageHeader__ImageWrapper") &&
            window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)")
              .matches &&
            (this.parallaxInstance = new Rellax(".PageHeader__ImageWrapper", {
              speed: -7,
              center: !1,
              round: !0,
            })),
          new w(this.element.querySelector(".ProductList")),
          (this.timeline = new TimelineLite({
            delay: window.theme.showPageTransition ? 0.5 : 0,
          })),
          this._setupAnimation(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.delegateElement.off("click"),
                this.sortPopover && this.sortPopover.destroy(),
                this.filterDrawer && this.filterDrawer.destroy(),
                this.filterInnerSidebarScroller &&
                  this.filterInnerSidebarScroller.destroy(),
                this.parallaxInstance && this.parallaxInstance.destroy(),
                window.theme.showElementStaggering &&
                  (this.intersectionObserver.disconnect(),
                  this.timeline.kill());
            },
          },
          {
            key: "_setupAnimation",
            value: function () {
              var e = this,
                t =
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0];
              window.theme.showElementStaggering &&
                (this.intersectionObserver &&
                  this.intersectionObserver.disconnect(),
                t
                  ? (this.timeline.clear(),
                    this.timeline.staggerFromTo(
                      this.element.querySelectorAll(
                        ".ProductList .ProductItem"
                      ),
                      0.35,
                      {
                        autoAlpha: 0,
                        y: 25,
                      },
                      {
                        autoAlpha: 1,
                        y: 0,
                      },
                      0.15
                    ))
                  : ((this.intersectionObserver = new IntersectionObserver(
                      this._reveal.bind(this),
                      {
                        threshold: 0.3,
                      }
                    )),
                    h
                      .nodeListToArray(
                        this.element.querySelectorAll(
                          ".ProductList .ProductItem"
                        )
                      )
                      .forEach(function (t) {
                        e.intersectionObserver.observe(t);
                      })));
            },
          },
          {
            key: "_reveal",
            value: function (e) {
              var t = this,
                i = [];
              e.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (i.push(e.target),
                  t.intersectionObserver.unobserve(e.target));
              }),
                0 !== i.length &&
                  this.timeline.staggerFromTo(
                    i,
                    0.45,
                    {
                      autoAlpha: 0,
                      y: 25,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                    },
                    0.2
                  );
            },
          },
          {
            key: "_changeLayoutMode",
            value: function (e, t) {
              var i,
                n,
                o,
                s = this,
                a = t.getAttribute("data-grid-type"),
                r = parseInt(t.getAttribute("data-count")),
                l = this.collectionInnerElement.querySelector(".ProductList");
              if (l) {
                var c = parseInt(l.getAttribute("data-".concat(a, "-count")));
                if (c === r) return;
                l.setAttribute("data-".concat(a, "-count"), r),
                  h
                    .nodeListToArray(l.querySelectorAll(".Grid__Cell"))
                    .forEach(function (e) {
                      if ("mobile" === a)
                        e.classList.remove("1/".concat(c, "--phone")),
                          e.classList.add("1/".concat(r, "--phone"));
                      else {
                        var t = 2 === c ? 2 : 3,
                          i = 2 === r ? 2 : 3;
                        "drawer" === s.settings.filterPosition
                          ? (e.classList.remove("1/".concat(c, "--lap-and-up")),
                            e.classList.add("1/".concat(r, "--lap-and-up")))
                          : (e.classList.remove("1/".concat(c, "--desk")),
                            e.classList.add("1/".concat(r, "--desk"))),
                          e.classList.remove("1/".concat(t, "--tablet-and-up")),
                          e.classList.add("1/".concat(i, "--tablet-and-up"));
                      }
                      window.theme.showElementStaggering &&
                        (e.firstElementChild.style.visibility = "hidden");
                    }),
                  lazySizes.autoSizer.checkElems();
              }
              t.classList.add("is-active"),
                h.getSiblings(t)[0].classList.remove("is-active"),
                this._setupAnimation(),
                fetch("".concat(window.routes.cartUrl, "/update.js"), {
                  body: JSON.stringify({
                    attributes:
                      ((i = {}),
                      (n = "collection_".concat(a, "_items_per_row")),
                      (o = r),
                      n in i
                        ? Object.defineProperty(i, n, {
                            value: o,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                          })
                        : (i[n] = o),
                      i),
                  }),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                });
            },
          },
          {
            key: "_sortByChanged",
            value: function (e) {
              var t = new URL(location.href);
              t.searchParams.set("sort_by", e),
                t.searchParams.delete("page"),
                this._reloadProducts(t.toString());
            },
          },
          {
            key: "_onFiltersCleared",
            value: function (e) {
              this._reloadProducts(e.target.getAttribute("data-url"));
            },
          },
          {
            key: "_onFilterChanged",
            value: function (e) {
              var t = new FormData(e.target.closest("form")),
                i = new URLSearchParams(t).toString();
              this._reloadProducts(
                "".concat(window.location.pathname, "?").concat(i)
              );
            },
          },
          {
            key: "_reloadProducts",
            value: function (e) {
              var t = this;
              this.abortController && this.abortController.abort(),
                document.dispatchEvent(new CustomEvent("theme:loading:start")),
                history.replaceState &&
                  window.history.pushState(
                    {
                      path: e,
                    },
                    "",
                    e
                  );
              var i = new URL(window.location);
              i.searchParams.set("section_id", this.settings.sectionId);
              try {
                (this.abortController = new AbortController()),
                  fetch(i.toString(), {
                    signal: this.abortController.signal,
                  }).then(function (e) {
                    e.text().then(function (e) {
                      var i = document.createElement("div");
                      (i.innerHTML = e),
                        (t.collectionInnerElement.innerHTML = i.querySelector(
                          ".CollectionInner__Products"
                        ).innerHTML);
                      var n = i.querySelector(
                        ".CollectionToolbar__Item--filter"
                      );
                      if (n) {
                        var o = t.element.querySelector(
                          ".CollectionToolbar__Item--filter"
                        );
                        (o.innerHTML = n.innerHTML),
                          (o.className = n.className);
                      }
                      var s = t.element.querySelector(
                          "#collection-filters-drawer-form"
                        ),
                        a = t.element.querySelector(
                          "#collection-filters-sidebar-form"
                        );
                      if (s) {
                        var r = i.querySelector(
                          "#collection-filters-drawer-form"
                        );
                        Array.from(s.querySelectorAll(".Collapsible")).forEach(
                          function (e) {
                            var t = r.querySelector(
                              '[data-filter-index="'.concat(
                                e.getAttribute("data-filter-index"),
                                '"]'
                              )
                            );
                            "true" ===
                              e.firstElementChild.getAttribute(
                                "aria-expanded"
                              ) &&
                              ((t.style.overflow = "visible"),
                              t.firstElementChild.setAttribute(
                                "aria-expanded",
                                "true"
                              ),
                              (t.lastElementChild.style.height = "auto"),
                              (t.lastElementChild.style.overflow = "visible"));
                          }
                        ),
                          (s.innerHTML = r.innerHTML);
                      }
                      if (a) {
                        var l = i.querySelector(
                          "#collection-filters-sidebar-form"
                        );
                        Array.from(a.querySelectorAll(".Collapsible")).forEach(
                          function (e) {
                            var t = l.querySelector(
                              '[data-filter-index="'.concat(
                                e.getAttribute("data-filter-index"),
                                '"]'
                              )
                            );
                            "true" ===
                              e.firstElementChild.getAttribute(
                                "aria-expanded"
                              ) &&
                              ((t.style.overflow = "visible"),
                              t.firstElementChild.setAttribute(
                                "aria-expanded",
                                "true"
                              ),
                              (t.lastElementChild.style.height = "auto"),
                              (t.lastElementChild.style.overflow = "visible"));
                          }
                        ),
                          (a.innerHTML = l.innerHTML);
                      }
                      document.dispatchEvent(
                        new CustomEvent("theme:loading:end")
                      ),
                        t._setupAnimation(!0);
                      var d =
                        t.element
                          .querySelector(".CollectionMain")
                          .getBoundingClientRect().top -
                        parseInt(
                          document.documentElement.style.getPropertyValue(
                            "--header-height"
                          )
                        );
                      c.matchesBreakpoint("lap-and-up") &&
                        t.toolbarElement &&
                        0 === t.toolbarElement.clientHeight &&
                        (d -= 50),
                        d < 0 &&
                          window.scrollBy({
                            top: d,
                            behavior: "smooth",
                          });
                    });
                  });
              } catch (e) {}
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._changeLayoutModeListener =
                this._changeLayoutMode.bind(this)),
                this.delegateElement.on(
                  "click",
                  '[data-action="change-layout-mode"]',
                  this._changeLayoutModeListener
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="clear-filters"]',
                  this._onFiltersCleared.bind(this)
                ),
                this.delegateElement.on(
                  "change",
                  '[name^="filter."]',
                  this._onFilterChanged.bind(this)
                ),
                window.addEventListener("popstate", function (e) {
                  e.state.path && (window.location.href = e.state.path);
                });
            },
          },
        ]),
        t
      );
    })(),
    z = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.delegateElement.off();
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              this._openItem(e.target);
            },
          },
          {
            key: "onBlockDeselect",
            value: function (e) {
              this._closeItem(e.target);
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                ".Faq__Question",
                this._toggleItem.bind(this)
              ),
                this.delegateElement.on(
                  "click",
                  ".FaqSummary__Item",
                  this._switchToCategory.bind(this)
                );
            },
          },
          {
            key: "_switchToCategory",
            value: function (e, t) {
              t.classList.add("is-active"),
                h.getSiblings(t, ".is-active").forEach(function (e) {
                  e.classList.remove("is-active");
                });
            },
          },
          {
            key: "_toggleItem",
            value: function (e, t) {
              var i = t.closest(".Faq__Item");
              "true" === i.getAttribute("aria-expanded")
                ? this._closeItem(i)
                : this._openItem(i);
            },
          },
          {
            key: "_openItem",
            value: function (e) {
              var t = e.querySelector(".Faq__AnswerWrapper");
              e.setAttribute("aria-expanded", "true"),
                t.setAttribute("aria-hidden", "false"),
                u.slideDown(t, !0),
                h
                  .getSiblings(e, '[aria-expanded="true"]')
                  .forEach(function (e) {
                    var t = e.querySelector(".Faq__AnswerWrapper");
                    e.setAttribute("aria-expanded", "false"),
                      t.setAttribute("aria-hidden", "true"),
                      u.slideUp(t);
                  });
            },
          },
          {
            key: "_closeItem",
            value: function (e) {
              var t = e.querySelector(".Faq__AnswerWrapper");
              e.setAttribute("aria-expanded", "false"),
                t.setAttribute("aria-hidden", "true"),
                u.slideUp(t);
            },
          },
        ]),
        t
      );
    })(),
    U = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-settings")
          )),
          (this.carousels = []),
          h
            .nodeListToArray(
              this.element.querySelectorAll("[data-flickity-config]")
            )
            .forEach(function (e) {
              n.carousels.push(new d(e));
            }),
          new w(this.element),
          this._setupAnimation(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.carousels.forEach(function (e) {
                return e.destroy();
              }),
                this.delegateElement.off("click"),
                this.intersectionObserver.disconnect(),
                this.timeline.kill();
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              this.element
                .querySelector('[aria-controls="'.concat(e.target.id, '"]'))
                .click();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                '[data-action="toggle-tab"]',
                this._switchTab.bind(this)
              );
            },
          },
          {
            key: "_switchTab",
            value: function (e, t) {
              var i = this;
              if (!t.classList.contains("is-active")) {
                t.classList.add("is-active"),
                  h.getSiblings(t, ".is-active").forEach(function (e) {
                    e.classList.remove("is-active");
                  });
                var n = this.element.querySelector(
                  "#".concat(t.getAttribute("aria-controls"))
                );
                this.timeline.eventCallback("onReverseComplete", function () {
                  n.setAttribute("aria-hidden", "false"),
                    h
                      .getSiblings(n, '.TabPanel[aria-hidden="false"]')
                      .forEach(function (e) {
                        e.setAttribute("aria-hidden", "true");
                      }),
                    c.matchesBreakpoint("lap-and-up") &&
                      i.carousels.forEach(function (e) {
                        e.flickityInstance.activate(),
                          e.flickityInstance.resize();
                      }),
                    i.timeline.clear(),
                    i._setupAnimation();
                }),
                  "grid" === this.options.layout &&
                  window.theme.showElementStaggering
                    ? this.timeline.reverse().timeScale(3)
                    : this.timeline.reverse();
              }
            },
          },
          {
            key: "_setupAnimation",
            value: function () {
              var e = this;
              if (
                (this.intersectionObserver &&
                  this.intersectionObserver.disconnect(),
                (this.timeline = new TimelineLite({
                  delay: 0.5,
                })),
                "grid" === this.options.layout &&
                  window.theme.showElementStaggering)
              )
                (this.intersectionObserver = new IntersectionObserver(
                  this._reveal.bind(this)
                )),
                  h
                    .nodeListToArray(
                      this.element.querySelectorAll(
                        '.TabPanel[aria-hidden="false"] .ProductList .ProductItem'
                      )
                    )
                    .forEach(function (t) {
                      e.intersectionObserver.observe(t);
                    });
              else {
                var t = this.element.querySelector(
                  '.TabPanel[aria-hidden="false"] .ProductList'
                );
                t &&
                  this.timeline.fromTo(
                    t,
                    0.6,
                    {
                      autoAlpha: 0,
                      y: 25,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                    }
                  );
              }
            },
          },
          {
            key: "_reveal",
            value: function (e) {
              var t = this,
                i = [];
              e.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (i.push(e.target),
                  t.intersectionObserver.unobserve(e.target));
              }),
                0 !== i.length &&
                  this.timeline.staggerFromTo(
                    i,
                    0.45,
                    {
                      autoAlpha: 0,
                      y: 25,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                    },
                    0.2
                  );
            },
          },
        ]),
        t
      );
    })(),
    W = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          this.options.usePlaceholder ||
            "coming-soon" === this.options.templateSuffix ||
            (this.productVariants = new T(i, this.options));
        var n = this.element.querySelector(".Product__OffScreen");
        n && this.element.appendChild(n), this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.delegateElement.off("click"),
                this.productVariants && this.productVariants.destroy();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "variant:changed",
                this._updateMainImage.bind(this)
              );
            },
          },
          {
            key: "_updateMainImage",
            value: function (e) {
              var t = e.detail.variant,
                i = e.detail.previousVariant;
              if (
                t &&
                t.featured_image &&
                (!i.featured_image ||
                  i.featured_image.id !== t.featured_image.id)
              ) {
                var n = t.featured_image,
                  o = this.element.querySelector(
                    ".FeaturedProduct__Gallery .AspectRatio"
                  );
                o.style.cssText = "max-width: "
                  .concat(n.width, "px; --aspect-ratio: ")
                  .concat(n.width / n.height);
                var s = document.createElement("img");
                s.classList.add("Image--lazyLoad"),
                  s.setAttribute(
                    "data-src",
                    b
                      .getSizedImageUrl(n.src, "1x1")
                      .replace("_1x1.", "_{width}x.")
                  ),
                  s.setAttribute(
                    "data-widths",
                    "[".concat(
                      b
                        .getSupportedSizes(
                          n,
                          [200, 400, 600, 700, 800, 900, 1e3]
                        )
                        .join(","),
                      "]"
                    )
                  ),
                  s.setAttribute("data-sizes", "auto"),
                  o.replaceChild(s, o.querySelector("img"));
              }
            },
          },
        ]),
        t
      );
    })(),
    j = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          this._loadScript().then(this._setupPlayer.bind(this));
      }
      return (
        i(t, [
          {
            key: "_loadScript",
            value: function () {
              var e = this;
              return new Promise(function (t, i) {
                var n = document.createElement("script");
                document.body.appendChild(n),
                  (n.onload = t),
                  (n.onerror = i),
                  (n.async = !0),
                  (n.src =
                    "youtube" === e.options.videoType
                      ? "//www.youtube.com/iframe_api"
                      : "//player.vimeo.com/api/player.js");
              });
            },
          },
          {
            key: "onUnload",
            value: function () {
              this.player && this.player.destroy();
            },
          },
          {
            key: "_setupPlayer",
            value: function () {
              var e = this,
                t = this.element.querySelector(".ImageHero__VideoHolder"),
                i = setInterval(function () {
                  "youtube" === e.options.videoType
                    ? window.YT &&
                      ((e.player = new YT.Player(t, {
                        videoId: e.options.videoId,
                        playerVars: {
                          showinfo: 0,
                          controls: 0,
                          fs: 0,
                          rel: 0,
                          height: "100%",
                          width: "100%",
                          iv_load_policy: 3,
                          html5: 1,
                          loop: 1,
                          playsinline: 1,
                          modestbranding: 1,
                          disablekb: 1,
                          origin: e.options.requestHost,
                        },
                        events: {
                          onReady: e._onYouTubeReady.bind(e),
                          onStateChange: e._onYouTubeStateChange.bind(e),
                        },
                      })),
                      clearInterval(i))
                    : window.Vimeo &&
                      ((e.player = new Vimeo.Player(t.parentNode, {
                        id: e.options.videoId,
                        autoplay: !0,
                        autopause: !1,
                        muted: !0,
                        background: !0,
                        loop: !0,
                      })),
                      clearInterval(i));
                }, 50);
            },
          },
          {
            key: "_onYouTubeReady",
            value: function (e) {
              this.player.mute(), this.player.playVideo();
            },
          },
          {
            key: "_onYouTubeStateChange",
            value: function (e) {
              e.data === YT.PlayerState.ENDED && this.player.playVideo();
            },
          },
        ]),
        t
      );
    })(),
    Y = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          this._createQrCode(),
          this._setupPrint();
      }
      return (
        i(t, [
          {
            key: "_createQrCode",
            value: function () {
              var e = document.getElementById("QrCode");
              new QRCode(e, {
                text: e.getAttribute("data-identifier"),
                width: 120,
                height: 120,
              });
            },
          },
          {
            key: "_setupPrint",
            value: function () {
              var e = document.getElementById("PrintGiftCard");
              e &&
                e.addEventListener("click", function () {
                  window.print();
                });
            },
          },
        ]),
        t
      );
    })(),
    Q = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          (this.lastScrollPosition = -1),
          (this.isTouch = window.matchMedia(
            "(-moz-touch-enabled: 1), (hover: none)"
          ).matches),
          this.options.isSticky && Stickyfill.addOne(this.element.parentNode),
          (this.searchBar = new q()),
          this._attachListeners(),
          this._verifyNavigationOverlap();
        var o = this.element.querySelector(".Header__LogoImage--primary");
        o && !o.complete
          ? o.addEventListener("load", function () {
              fastdom.measure(function () {
                document.documentElement.style.setProperty(
                  "--header-height",
                  n.element.clientHeight + "px"
                ),
                  document.documentElement.style.setProperty(
                    "--header-is-not-transparent",
                    n.options.hasTransparentHeader ? 0 : 1
                  );
              });
            })
          : fastdom.measure(function () {
              document.documentElement.style.setProperty(
                "--header-height",
                n.element.clientHeight + "px"
              ),
                document.documentElement.style.setProperty(
                  "--header-is-not-transparent",
                  n.options.hasTransparentHeader ? 0 : 1
                );
            }),
          window.addEventListener(
            "pageshow",
            this._checkTransparentHeader.bind(this)
          ),
          this._setupLocalizationPopovers();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.element.removeEventListener(
                "mouseleave",
                this._closeNavigationListener
              ),
                this.element.removeEventListener(
                  "mouseenter",
                  this._focusNavigationListener
                ),
                this.element.removeEventListener(
                  "focusin",
                  this._focusNavigationListener
                ),
                this.delegateElement.off(),
                window.removeEventListener(
                  "scroll",
                  this._checkTransparentHeaderListener
                ),
                window.removeEventListener(
                  "resize",
                  this._verifyNavigationOverlapListener
                ),
                this.options.isSticky &&
                  Stickyfill.removeOne(this.element.parentNode),
                this.searchBar.destroy(),
                this.localizationPopovers.forEach(function (e) {
                  e.destroy();
                });
            },
          },
          {
            key: "onSelect",
            value: function () {
              this._checkTransparentHeader();
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              var t = this,
                i = e.target.closest(".HorizontalList__Item");
              fastdom.mutate(function () {
                e.target.setAttribute("aria-hidden", "false"),
                  i &&
                    (i.classList.add("is-expanded"),
                    h.getSiblings(i, ".is-expanded").forEach(function (e) {
                      e.classList.remove("is-expanded");
                    })),
                  t.element.classList.remove("Header--transparent");
              });
            },
          },
          {
            key: "onBlockDeselect",
            value: function (e) {
              var t = e.target.closest(".HorizontalList__Item");
              fastdom.mutate(function () {
                e.target.setAttribute("aria-hidden", "true"),
                  t && t.classList.remove("is-expanded");
              }),
                this._checkTransparentHeader();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._checkTransparentHeaderListener =
                this._checkTransparentHeader.bind(this)),
                (this._closeNavigationListener =
                  this._closeNavigation.bind(this)),
                (this._focusNavigationListener =
                  this._focusNavigation.bind(this)),
                (this._verifyNavigationOverlapListener =
                  this._verifyNavigationOverlap.bind(this)),
                this.element.addEventListener(
                  "mouseleave",
                  this._closeNavigationListener
                ),
                this.delegateElement.on(
                  "mouseenter",
                  ".Header__MainNav .HorizontalList__Item, [aria-haspopup]",
                  this._openMenu.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "focusin",
                  "[aria-haspopup]",
                  this._openMenu.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "focusout",
                  "[aria-haspopup]",
                  this._closeMenu.bind(this),
                  !1
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="toggle-search"]',
                  this._closeNavigationListener
                ),
                this.delegateElement.on(
                  "mouseleave",
                  ".DropdownMenu [aria-haspopup]",
                  this._closeMenu.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "mouseenter",
                  ".DropdownMenu [aria-haspopup]",
                  this._adjustDropdownPosition.bind(this),
                  !0
                ),
                this.isTouch &&
                  this.delegateElement.on(
                    "click",
                    ".Header__MainNav [aria-haspopup]",
                    this._handleTouchMenu.bind(this)
                  ),
                this.options.hasTransparentHeader &&
                  (this.element.addEventListener(
                    "mouseenter",
                    this._focusNavigationListener
                  ),
                  this.element.addEventListener(
                    "focusin",
                    this._focusNavigationListener
                  )),
                this.options.isSticky &&
                  this.options.hasTransparentHeader &&
                  window.addEventListener(
                    "scroll",
                    this._checkTransparentHeaderListener
                  ),
                ("inline" !== this.options.navigationStyle &&
                  "logoLeft" !== this.options.navigationStyle) ||
                  window.addEventListener(
                    "resize",
                    this._verifyNavigationOverlapListener
                  );
            },
          },
          {
            key: "_setupLocalizationPopovers",
            value: function () {
              (this.localizationPopovers = []),
                h
                  .nodeListToArray(
                    document.querySelectorAll("#header-locale-popover")
                  )
                  .forEach(function (e, t) {
                    e.id = "".concat(e.id, "-").concat(t);
                  }),
                h
                  .nodeListToArray(
                    document.querySelectorAll(
                      '[aria-controls="header-locale-popover"]'
                    )
                  )
                  .forEach(function (e, t) {
                    e.setAttribute(
                      "aria-controls",
                      "".concat(e.getAttribute("aria-controls"), "-").concat(t)
                    );
                  }),
                h
                  .nodeListToArray(
                    document.querySelectorAll("#header-currency-popover")
                  )
                  .forEach(function (e, t) {
                    e.id = "".concat(e.id, "-").concat(t);
                  }),
                h
                  .nodeListToArray(
                    document.querySelectorAll(
                      '[aria-controls="header-currency-popover"]'
                    )
                  )
                  .forEach(function (e, t) {
                    e.setAttribute(
                      "aria-controls",
                      "".concat(e.getAttribute("aria-controls"), "-").concat(t)
                    );
                  });
              var e = document.getElementById("header-locale-popover-0");
              e &&
                this.localizationPopovers.push(
                  new g(e, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
              var t = document.getElementById("header-locale-popover-1");
              t &&
                this.localizationPopovers.push(
                  new g(t, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
              var i = document.getElementById("header-currency-popover-0");
              i &&
                this.localizationPopovers.push(
                  new g(i, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
              var n = document.getElementById("header-currency-popover-1");
              n &&
                this.localizationPopovers.push(
                  new g(n, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
            },
          },
          {
            key: "_focusNavigation",
            value: function () {
              var e = this;
              fastdom.mutate(function () {
                (e.isTouch && !c.matchesBreakpoint("desk")) ||
                  e.element.classList.remove("Header--transparent");
              });
            },
          },
          {
            key: "_closeNavigation",
            value: function () {
              var e = this;
              fastdom.mutate(function () {
                h
                  .nodeListToArray(e.element.querySelectorAll(".is-expanded"))
                  .forEach(function (e) {
                    e.classList.remove("is-expanded");
                  }),
                  h
                    .nodeListToArray(
                      e.element.querySelectorAll(
                        '.Header__MainNav [aria-hidden="false"]'
                      )
                    )
                    .forEach(function (e) {
                      e.setAttribute("aria-hidden", "true");
                    });
              }),
                this.options.hasTransparentHeader &&
                  this._checkTransparentHeader();
            },
          },
          {
            key: "_openMenu",
            value: function (e, t) {
              ("mouseenter" === e.type && t !== e.target) ||
                fastdom.mutate(function () {
                  t.classList.add("is-expanded"),
                    h
                      .nodeListToArray(
                        t.children,
                        '.Header__MainNav [aria-hidden="true"]'
                      )
                      .forEach(function (e) {
                        e.setAttribute("aria-hidden", "false");
                      }),
                    h.getSiblings(t, ".is-expanded").forEach(function (e) {
                      e.classList.remove("is-expanded"),
                        h
                          .nodeListToArray(
                            e.children,
                            '.Header__MainNav [aria-hidden="false"]'
                          )
                          .forEach(function (e) {
                            e.setAttribute("aria-hidden", "true");
                          });
                    });
                });
            },
          },
          {
            key: "_closeMenu",
            value: function (e, t) {
              ("mouseleave" === e.type && t !== e.target) ||
                fastdom.mutate(function () {
                  t.classList.remove("is-expanded"),
                    h
                      .nodeListToArray(
                        t.children,
                        '.Header__MainNav [aria-hidden="false"]'
                      )
                      .forEach(function (e) {
                        e.setAttribute("aria-hidden", "true");
                      });
                });
            },
          },
          {
            key: "_adjustDropdownPosition",
            value: function (e, t) {
              var i = h.nodeListToArray(t.querySelectorAll(".DropdownMenu")),
                n = !1;
              fastdom.measure(function () {
                var e = window.innerWidth,
                  o = t.getBoundingClientRect().right;
                i.forEach(function (t) {
                  o + t.offsetWidth > e && (n = !0);
                });
              }),
                fastdom.mutate(function () {
                  n
                    ? i.forEach(function (e) {
                        e.classList.add("DropdownMenu--reversed");
                      })
                    : i.forEach(function (e) {
                        e.classList.remove("DropdownMenu--reversed");
                      });
                });
            },
          },
          {
            key: "_handleTouchMenu",
            value: function (e, t) {
              t.classList.contains("is-expanded") || e.preventDefault();
            },
          },
          {
            key: "_verifyNavigationOverlap",
            value: function () {
              var e = this,
                t = !1,
                i = this.element.querySelector(".Header__MainNav");
              fastdom.measure(function () {
                if (i) {
                  var e = h.outerHeightWithMargin(
                    i.querySelector(".HorizontalList__Item")
                  );
                  i.scrollHeight > e && (t = !0);
                }
              }),
                this.element.classList.remove(
                  "Header--logoLeft",
                  "Header--inline",
                  "Header--center"
                ),
                this.element.classList.add(
                  "Header--".concat(this.options.navigationStyle)
                ),
                this.element.clientWidth,
                fastdom.mutate(function () {
                  if (t) {
                    if (
                      (e.element.classList.remove(
                        "Header--".concat(e.options.navigationStyle)
                      ),
                      e.element.classList.add("Header--center"),
                      i)
                    ) {
                      var n = new Set();
                      Array.from(
                        i.querySelectorAll(".HorizontalList__Item")
                      ).forEach(function (e) {
                        n.add(e.getBoundingClientRect().top);
                      }),
                        (t = n.size > 1);
                    }
                  } else e.element.classList.add("Header--".concat(e.options.navigationStyle)), e.element.classList.remove("Header--center");
                  e.element
                    .querySelector(".Header__FlexItem--logo")
                    .classList.toggle("Header__FlexItem--increaseSpace", t),
                    e.element.classList.add("Header--initialized"),
                    fastdom.measure(function () {
                      document.documentElement.style.setProperty(
                        "--header-height",
                        e.element.clientHeight + "px"
                      );
                    });
                });
            },
          },
          {
            key: "_checkTransparentHeader",
            value: function () {
              var e = this;
              if (this.options.hasTransparentHeader) {
                fastdom.measure(function () {
                  e.lastScrollPosition = window.pageYOffset;
                }),
                  fastdom.mutate(function () {
                    e.lastScrollPosition <= 10
                      ? e.element.classList.add("Header--transparent")
                      : e.element.classList.remove("Header--transparent");
                  });
              }
            },
          },
        ]),
        t
      );
    })(),
    K = (function () {
      function t(i) {
        e(this, t), (this.element = i);
        var n = document.getElementById("footer-locale-popover");
        n &&
          (this.localePopover = new g(n, {
            preferredAlignment: "center",
            preferredPosition: "top",
            threshold: 12,
          }));
        var o = document.getElementById("footer-currency-popover");
        o &&
          (this.currencyPopover = new g(o, {
            preferredAlignment: "center",
            preferredPosition: "top",
            threshold: 12,
          }));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.localePopover && this.localePopover.destroy(),
                this.currencyPopover && this.currencyPopover.destroy();
            },
          },
        ]),
        t
      );
    })(),
    Z = (function () {
      function t(i) {
        e(this, t), (this.element = i);
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {},
          },
        ]),
        t
      );
    })(),
    J = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.timelineLite = new TimelineLite()),
          (this.customerLoginForm =
            this.element.querySelector("#customer_login")),
          (this.recoverPasswordForm = this.element.querySelector(
            "#recover_customer_password"
          )),
          this.delegateElement.on(
            "click",
            '[data-action="toggle-recover-form"]',
            this._showRecoverPassword.bind(this)
          );
      }
      return (
        i(t, [
          {
            key: "_showRecoverPassword",
            value: function () {
              "block" === this.customerLoginForm.style.display
                ? this.timelineLite
                    .fromTo(
                      this.customerLoginForm,
                      0.5,
                      {
                        autoAlpha: 1,
                        display: "block",
                        y: 0,
                      },
                      {
                        autoAlpha: 0,
                        y: 20,
                        display: "none",
                      }
                    )
                    .fromTo(
                      this.recoverPasswordForm,
                      0.5,
                      {
                        autoAlpha: 0,
                        display: "none",
                        y: 20,
                      },
                      {
                        autoAlpha: 1,
                        display: "block",
                        y: 0,
                        delay: 0.25,
                      }
                    )
                : this.timelineLite
                    .fromTo(
                      this.recoverPasswordForm,
                      0.5,
                      {
                        autoAlpha: 1,
                        display: "block",
                        y: 0,
                      },
                      {
                        autoAlpha: 0,
                        y: 20,
                        display: "none",
                      }
                    )
                    .fromTo(
                      this.customerLoginForm,
                      0.5,
                      {
                        autoAlpha: 0,
                        display: "none",
                        y: 20,
                      },
                      {
                        autoAlpha: 1,
                        display: "block",
                        y: 0,
                        delay: 0.25,
                      }
                    );
            },
          },
        ]),
        t
      );
    })(),
    G = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(i.getAttribute("data-section-settings"))),
          this.options.apiKey &&
            this.options.mapAddress &&
            this._loadScript().then(this._initMap.bind(this));
      }
      return (
        i(t, [
          {
            key: "_loadScript",
            value: function () {
              var e = this;
              return new Promise(function (t, i) {
                var n = document.createElement("script");
                document.body.appendChild(n),
                  (n.onload = t),
                  (n.onerror = i),
                  (n.async = !0),
                  (n.src =
                    "https://maps.googleapis.com/maps/api/js?key=".concat(
                      e.options.apiKey
                    ));
              });
            },
          },
          {
            key: "_initMap",
            value: function () {
              var e = this;
              new google.maps.Geocoder().geocode(
                {
                  address: this.options.mapAddress,
                },
                function (t, i) {
                  if (i !== google.maps.GeocoderStatus.OK) Shopify.designMode;
                  else {
                    var n = {
                        zoom: e.options.zoom,
                        center: t[0].geometry.location,
                        draggable: !1,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        disableDoubleClickZoom: !0,
                        disableDefaultUI: !0,
                      },
                      o = new google.maps.Map(
                        e.element.querySelector(".FeaturedMap__GMap"),
                        n
                      ),
                      s = o.getCenter();
                    o.setCenter(s);
                    var a = {
                      path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
                      fillColor: e.options.markerColor,
                      fillOpacity: 1,
                      anchor: new google.maps.Point(15, 55),
                      strokeWeight: 0,
                      scale: 0.6,
                    };
                    new google.maps.Marker({
                      map: o,
                      position: o.getCenter(),
                      icon: a,
                    });
                    var r = new google.maps.StyledMapType(
                      JSON.parse(
                        e.element.querySelector("[data-gmap-style]").innerHTML
                      )
                    );
                    o.mapTypes.set("styled_map", r),
                      o.setMapTypeId("styled_map"),
                      google.maps.event.addDomListener(
                        window,
                        "resize",
                        function () {
                          google.maps.event.trigger(o, "resize"),
                            o.setCenter(s);
                        }
                      );
                  }
                }
              );
            },
          },
        ]),
        t
      );
    })(),
    X = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(i.getAttribute("data-section-settings")));
        try {
          "#newsletter-popup" === window.location.hash &&
          null !== window.theme.pageType
            ? this._openPopup()
            : (!this.options.showOnlyOnce ||
                (this.options.showOnlyOnce &&
                  null === localStorage.getItem("themePopup"))) &&
              setTimeout(
                this._openPopup.bind(this),
                1e3 * this.options.apparitionDelay
              );
        } catch (e) {}
        this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.delegateElement.off();
            },
          },
          {
            key: "onSelect",
            value: function () {
              this._openPopup();
            },
          },
          {
            key: "onDeselect",
            value: function () {
              this._closePopup();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                '[data-action="close-popup"]',
                this._closePopup.bind(this)
              );
            },
          },
          {
            key: "_openPopup",
            value: function () {
              this.element.setAttribute("aria-hidden", "false"),
                localStorage.setItem("themePopup", "true");
            },
          },
          {
            key: "_closePopup",
            value: function () {
              this.element.setAttribute("aria-hidden", "true");
            },
          },
        ]),
        t
      );
    })(),
    $ = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          this.options.useRecommendations
            ? this._loadRecommendations().then(this._createSlideshow.bind(this))
            : this._createSlideshow();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.carousel.destroy();
            },
          },
          {
            key: "_loadRecommendations",
            value: function () {
              var e = this,
                t = ""
                  .concat(
                    window.routes.productRecommendationsUrl,
                    "?section_id="
                  )
                  .concat(
                    this.element.getAttribute("data-section-id"),
                    "&product_id="
                  )
                  .concat(this.options.productId, "&limit=")
                  .concat(this.options.recommendationsCount);
              return fetch(t).then(function (t) {
                return t.text().then(function (t) {
                  var i = document.createElement("div");
                  (i.innerHTML = t),
                    (e.element.querySelector(
                      ".ProductRecommendations"
                    ).innerHTML = i.querySelector(
                      ".ProductRecommendations"
                    ).innerHTML);
                });
              });
            },
          },
          {
            key: "_createSlideshow",
            value: function () {
              var e = this.element.querySelector("[data-flickity-config]");
              e && ((this.carousel = new d(e)), new w(this.element));
            },
          },
        ]),
        t
      );
    })(),
    ee = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          (this.viewInSpaceElement =
            this.element.querySelector("[data-shopify-xr]")),
          "coming-soon" !== this.options.templateSuffix &&
            (this.productVariants = new T(i, this.options)),
          (this.productReviews = new L(i));
        var o = this.element.querySelector(".Product__Slideshow");
        o &&
          ((this.productSlideshow = new d(
            o,
            {
              onSelect: this._onImageChanged.bind(this),
              onSettle: this._onImageSettled.bind(this),
            },
            {
              draggable: !c.matchesBreakpoint("supports-hover"),
            }
          )),
          (this.mediaList = {}),
          (this.previouslySelectedMedia = null),
          o.querySelectorAll('[data-media-type="model"]').forEach(function (e) {
            n.mediaList[e.getAttribute("data-media-id")] = new S(
              e,
              n.options.stackProductImages
            );
          }),
          o
            .querySelectorAll(
              '[data-media-type="video"], [data-media-type="external_video"]'
            )
            .forEach(function (e) {
              n.mediaList[e.getAttribute("data-media-id")] = new P(
                e,
                n.options.stackProductImages,
                n.options.enableVideoLooping
              );
            }),
          this.options.stackProductImages &&
            ((this.slideshowNavDots = this.element.querySelector(
              ".Product__SlideshowNav--dots"
            )),
            (this.slideshowNavDotsItems = this.slideshowNavDots
              ? h.nodeListToArray(this.slideshowNavDots.querySelectorAll("a"))
              : [])),
          this.options.showThumbnails &&
            ((this.slideshowNavThumbnails = this.element.querySelector(
              ".Product__SlideshowNav--thumbnails"
            )),
            (this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails
              ? h.nodeListToArray(
                  this.slideshowNavThumbnails.querySelectorAll(
                    ".Product__SlideshowNavImage"
                  )
                )
              : [])),
          (this.slideshowImages = h.nodeListToArray(
            o.querySelectorAll(".Carousel__Cell")
          )),
          this._setupSlideshowMobileNav()),
          (this.productWrapperElement =
            this.element.querySelector(".Product__Wrapper")),
          (this.productInfoElement =
            this.element.querySelector(".Product__Info")),
          (this.productAsideElement =
            this.element.querySelector(".Product__Aside")),
          (this.productGalleryElement =
            this.element.querySelector(".Product__Gallery")),
          (this.quickNav = this.element.querySelector(".Product__QuickNav")),
          this.options.enableImageZoom &&
            (this.imageZoomInstance = new k(
              this.element,
              this.productSlideshow
            )),
          Stickyfill.addOne(this.productInfoElement);
        var s = this.element.querySelector(".Product__OffScreen");
        s && this.element.appendChild(s),
          this._setupDeviceFeatures(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.delegateElement.off("click"),
                this.productReviews.destroy(),
                this.productVariants && this.productVariants.destroy(),
                this.productSlideshow && this.productSlideshow.destroy(),
                this.options.enableImageZoom &&
                  this.imageZoomInstance.destroy(),
                this.carouselNavScrollSpy &&
                  this.carouselNavScrollSpy.destroy(),
                this.quickNav &&
                  window.removeEventListener(
                    "scroll",
                    this._checkQuickNavListener
                  ),
                this.productInfoScroller && this.productInfoScroller.destroy(),
                this.productThumbnailsScroller &&
                  this.productThumbnailsScroller.destroy(),
                window.ResizeObserver &&
                  this.productInfoResizeObserver &&
                  this.productInfoResizeObserver.disconnect(),
                Stickyfill.removeOne(this.productInfoElement),
                document.removeEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                );
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._onBreakpointChangedListener =
                this._setupDeviceFeatures.bind(this)),
                (this._checkQuickNavListener = this._checkQuickNav.bind(this)),
                this.delegateElement.on(
                  "click",
                  '[data-action="toggle-social-share"]',
                  this._toggleSocialShare.bind(this)
                ),
                this.delegateElement.on(
                  "variant:changed",
                  this._updateSlideshowImage.bind(this)
                ),
                this.delegateElement.on(
                  "scrollspy:target:changed",
                  this._onScrollTargetChanged.bind(this)
                ),
                this.delegateElement.on(
                  "model:played",
                  this._onMediaPlayed.bind(this)
                ),
                this.delegateElement.on(
                  "video:played",
                  this._onMediaPlayed.bind(this)
                ),
                this.delegateElement.on(
                  "model:paused",
                  this._onMediaPaused.bind(this)
                ),
                this.delegateElement.on(
                  "video:paused",
                  this._onMediaPaused.bind(this)
                ),
                document.addEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                ),
                this.quickNav &&
                  window.addEventListener(
                    "scroll",
                    this._checkQuickNavListener
                  ),
                !this.options.stackProductImages &&
                  this.options.showThumbnails &&
                  this.delegateElement.on(
                    "click",
                    ".Product__SlideshowNavImage",
                    this._switchToImage.bind(this)
                  );
            },
          },
          {
            key: "_setupSlideshowMobileNav",
            value: function () {
              var e = this;
              if (
                ((this.slideshowMobileNav = this.element.querySelector(
                  ".Product__SlideshowMobileNav"
                )),
                this.slideshowMobileNav)
              ) {
                var t = new domDelegate.Delegate(this.slideshowMobileNav);
                t.on("click", ".dot", function (t, i) {
                  e._slideWillChange(),
                    e.productSlideshow.selectCell(
                      parseInt(i.getAttribute("data-index"))
                    );
                }),
                  t.on("click", ".Product__SlideshowNavArrow", function (t, i) {
                    e._slideWillChange(),
                      "next" === i.getAttribute("data-direction")
                        ? e.productSlideshow.next()
                        : e.productSlideshow.previous();
                  });
              }
            },
          },
          {
            key: "_updateSlideshowImage",
            value: function (e) {
              var t = e.detail.variant,
                i = e.detail.previousVariant;
              if (
                t &&
                t.featured_media &&
                (!i ||
                  !i.featured_media ||
                  i.featured_media.id !== t.featured_media.id)
              )
                if (
                  (this._slideWillChange(),
                  c.matchesBreakpoint("pocket") ||
                    !this.options.stackProductImages)
                )
                  for (
                    var n = 0;
                    n !== this.productSlideshow.flickityInstance.cells.length;
                    ++n
                  ) {
                    var o =
                      this.productSlideshow.flickityInstance.cells[n].element;
                    parseInt(o.getAttribute("data-media-id")) ===
                      t.featured_media.id &&
                      this.productSlideshow.selectCell(
                        parseInt(o.getAttribute("data-media-position")) - 1
                      );
                  }
                else
                  document
                    .querySelector(
                      '[href="#Media'.concat(t.featured_media.id, '"]')
                    )
                    .click();
            },
          },
          {
            key: "_onMediaPlayed",
            value: function (e) {
              (this.productSlideshow.getFlickityInstance().options.draggable =
                !1),
                this.productSlideshow.getFlickityInstance().unbindDrag(),
                this.previouslySelectedMedia &&
                  this.previouslySelectedMedia !== e.target &&
                  this.mediaList[
                    this.previouslySelectedMedia.getAttribute("data-media-id")
                  ].hasBeenDeselected(),
                this.options.stackProductImages &&
                  (this.previouslySelectedMedia = e.target);
            },
          },
          {
            key: "_onMediaPaused",
            value: function () {
              (this.productSlideshow.getFlickityInstance().options.draggable =
                !c.matchesBreakpoint("supports-hover")),
                this.productSlideshow.getFlickityInstance().bindDrag();
            },
          },
          {
            key: "_handleMedia",
            value: function (e) {
              if (
                this.previouslySelectedMedia &&
                this.previouslySelectedMedia !== e
              ) {
                switch (
                  this.previouslySelectedMedia.getAttribute("data-media-type")
                ) {
                  case "video":
                  case "external_video":
                  case "model":
                    this.mediaList[
                      this.previouslySelectedMedia.getAttribute("data-media-id")
                    ].hasBeenDeselected();
                }
                "model" ===
                  this.previouslySelectedMedia.getAttribute(
                    "data-media-type"
                  ) &&
                  this.viewInSpaceElement &&
                  this.viewInSpaceElement.setAttribute(
                    "data-shopify-model3d-id",
                    this.viewInSpaceElement.getAttribute(
                      "data-shopify-model3d-default-id"
                    )
                  );
              }
              switch (e.getAttribute("data-media-type")) {
                case "video":
                case "external_video":
                case "model":
                  this.mediaList[
                    e.getAttribute("data-media-id")
                  ].hasBeenSelected();
              }
              "model" === e.getAttribute("data-media-type") &&
                this.viewInSpaceElement &&
                this.viewInSpaceElement.setAttribute(
                  "data-shopify-model3d-id",
                  e.getAttribute("data-media-id")
                ),
                (this.previouslySelectedMedia = e);
            },
          },
          {
            key: "_onScrollTargetChanged",
            value: function (e) {
              this.options.stackProductImages &&
                (this.slideshowNavDotsItems.forEach(function (e) {
                  return e.classList.remove("is-selected");
                }),
                this.slideshowNavDotsItems[
                  parseInt(
                    e.detail.newTarget.getAttribute("data-media-position")
                  ) - 1
                ].classList.add("is-selected"),
                this.options.showThumbnails &&
                  (this.slideshowNavThumbnailsItems.forEach(function (e) {
                    return e.classList.remove("is-selected");
                  }),
                  this.slideshowNavThumbnailsItems[
                    parseInt(
                      e.detail.newTarget.getAttribute("data-media-position")
                    ) - 1
                  ].classList.add("is-selected")));
            },
          },
          {
            key: "_switchToImage",
            value: function (e, t) {
              e.preventDefault(), this._slideWillChange();
              for (
                var i = 0;
                i !== this.productSlideshow.flickityInstance.cells.length;
                ++i
              ) {
                var n = this.productSlideshow.flickityInstance.cells[i].element;
                parseInt(n.getAttribute("data-media-id")) ===
                  parseInt(t.getAttribute("data-media-id")) &&
                  this.productSlideshow.selectCell(
                    parseInt(n.getAttribute("data-media-position")) - 1
                  );
              }
            },
          },
          {
            key: "_checkQuickNav",
            value: function () {
              var e = this,
                t = !1;
              fastdom.measure(function () {
                t =
                  window.scrollY >=
                  e.productAsideElement.offsetTop -
                    e.productAsideElement.clientHeight;
              }),
                fastdom.mutate(function () {
                  t
                    ? e.quickNav.classList.add("is-flipped")
                    : e.quickNav.classList.remove("is-flipped");
                });
            },
          },
          {
            key: "_toggleSocialShare",
            value: function (e, t) {
              t.classList.toggle("is-active"),
                t.classList.toggle("RoundButton--secondaryState"),
                t.setAttribute(
                  "aria-expanded",
                  "true" === t.getAttribute("aria-expanded") ? "false" : "true"
                ),
                t.nextElementSibling.setAttribute(
                  "aria-hidden",
                  "true" === t.nextElementSibling.getAttribute("aria-hidden")
                    ? "false"
                    : "true"
                );
            },
          },
          {
            key: "_onImageChanged",
            value: function (e, t) {
              if (c.matchesBreakpoint("pocket")) {
                var i = this.element.querySelector(
                  ".Product__Gallery .Product__ActionList"
                );
                i &&
                  (t.classList.contains("Product__SlideItem--image")
                    ? i.classList.remove("is-hidden")
                    : i.classList.add("is-hidden"));
              }
              if (
                !this.options.stackProductImages &&
                this.options.showThumbnails
              ) {
                var n = t.getAttribute("data-media-id");
                this.slideshowNavThumbnailsItems.forEach(function (e) {
                  e.getAttribute("data-media-id") === n
                    ? e.classList.add("is-selected")
                    : e.classList.remove("is-selected");
                });
              }
              if (this.slideshowMobileNav) {
                var o = parseInt(t.getAttribute("data-media-position")) - 1;
                h.nodeListToArray(
                  this.slideshowMobileNav.querySelectorAll(".dot")
                ).forEach(function (e, t) {
                  t === o
                    ? e.classList.add("is-selected")
                    : e.classList.remove("is-selected");
                });
              }
            },
          },
          {
            key: "_onImageSettled",
            value: function (e, t) {
              (this._handleMedia(t), c.matchesBreakpoint("lap-and-up")) &&
                this.element
                  .querySelectorAll(".Product__SlideItem:not(.is-selected)")
                  .forEach(function (e) {
                    e.classList.add("Product__SlideItem--hidden");
                  });
            },
          },
          {
            key: "_slideWillChange",
            value: function () {
              c.matchesBreakpoint("lap-and-up") &&
                this.element
                  .querySelectorAll(".Product__SlideItem")
                  .forEach(function (e) {
                    e.classList.remove("Product__SlideItem--hidden");
                  });
            },
          },
          {
            key: "_setupDeviceFeatures",
            value: function (e) {
              var t = this,
                i = e ? e.detail.currentBreakpoint : c.getCurrentBreakpoint();
              if (i !== (e ? e.detail.previousBreakpoint : null))
                if ("phone" === i || "tablet" === i)
                  this.carouselNavScrollSpy &&
                    this.carouselNavScrollSpy.destroy(),
                    this.productInfoScroller &&
                      this.productInfoScroller.destroy(),
                    this.productThumbnailsScroller &&
                      this.productThumbnailsScroller.destroy(),
                    this.productAsideElement
                      ? (this.productAsideElement.style.minHeight = null)
                      : (this.productWrapperElement.style.minHeight = null),
                    (this.productInfoElement.parentNode.style.maxHeight = null);
                else {
                  if (this.slideshowImages && this.slideshowImages.length > 1) {
                    var n = 0;
                    this.options.stackProductImages &&
                      this.slideshowNavDots &&
                      (n = this.slideshowNavDots.firstElementChild.offsetTop),
                      this.options.showThumbnails &&
                        c.matchesBreakpoint("desk") &&
                        (n = 250),
                      (this.carouselNavScrollSpy = new x(
                        this.element,
                        this.slideshowImages,
                        {
                          rootMargin: "-".concat(n, "px 0px 0px 0px"),
                        }
                      ));
                  }
                  var o = window.getComputedStyle(this.productInfoElement),
                    s = parseInt(o.paddingTop) + parseInt(o.paddingBottom),
                    a = this.productGalleryElement
                      ? parseInt(this.productGalleryElement.scrollHeight)
                      : 0,
                    r = function () {
                      t.productAsideElement
                        ? ((t.productAsideElement.style.minHeight = "".concat(
                            t.productInfoElement.scrollHeight - s - a,
                            "px"
                          )),
                          (t.productInfoElement.closest(
                            ".Product__InfoWrapper"
                          ).style.maxHeight =
                            t.productAsideElement.offsetTop +
                            t.productInfoElement.scrollHeight -
                            s +
                            "px"))
                        : (t.productWrapperElement.style.minHeight = "".concat(
                            t.productInfoElement.scrollHeight -
                              parseInt(o.paddingTop),
                            "px"
                          ));
                    };
                  r(),
                    window.ResizeObserver &&
                      ((this.productInfoResizeObserver = new ResizeObserver(
                        function () {
                          r();
                        }
                      )),
                      this.productInfoResizeObserver.observe(
                        this.productInfoElement
                      )),
                    (this.productInfoScroller = new R(this.productInfoElement)),
                    this.options.showThumbnails &&
                      this.slideshowNavThumbnails &&
                      (this.productThumbnailsScroller = new R(
                        this.slideshowNavThumbnails
                      ));
                }
            },
          },
        ]),
        t
      );
    })(),
    te = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          new w(this.element),
          this._fetchProducts();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.carousel && this.carousel.destroy();
            },
          },
          {
            key: "_fetchProducts",
            value: function () {
              var e = this,
                t = this._getSearchQueryString();
              "" !== t &&
                fetch(
                  ""
                    .concat(window.routes.searchUrl, "?section_id=")
                    .concat(
                      this.element.getAttribute("data-section-id"),
                      "&type=product&q="
                    )
                    .concat(t),
                  {
                    credentials: "same-origin",
                    method: "GET",
                  }
                ).then(function (t) {
                  t.text().then(function (t) {
                    var i = document.createElement("div");
                    (i.innerHTML = t),
                      (e.element.innerHTML =
                        i.querySelector(".Section").innerHTML),
                      (e.element.parentNode.style.display = "block"),
                      (e.carousel = new d(
                        e.element.querySelector("[data-flickity-config]")
                      ));
                  });
                });
            },
          },
          {
            key: "_getSearchQueryString",
            value: function () {
              var e = JSON.parse(
                localStorage.getItem("recentlyViewedProducts") || "[]"
              );
              return (
                e.includes(this.options.productId) &&
                  e.splice(e.indexOf(this.options.productId), 1),
                e
                  .map(function (e) {
                    return "id:" + e;
                  })
                  .join(" OR ")
              );
            },
          },
        ]),
        t
      );
    })(),
    ie = (function () {
      function t() {
        e(this, t),
          (this.constructors = []),
          (this.instances = []),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "_attachListeners",
            value: function () {
              document.addEventListener(
                "shopify:section:load",
                this._onSectionLoad.bind(this)
              ),
                document.addEventListener(
                  "shopify:section:unload",
                  this._onSectionUnload.bind(this)
                ),
                document.addEventListener(
                  "shopify:section:select",
                  this._onSelect.bind(this)
                ),
                document.addEventListener(
                  "shopify:section:deselect",
                  this._onDeselect.bind(this)
                ),
                document.addEventListener(
                  "shopify:section:reorder",
                  this._onReorder.bind(this)
                ),
                document.addEventListener(
                  "shopify:block:select",
                  this._onBlockSelect.bind(this)
                ),
                document.addEventListener(
                  "shopify:block:deselect",
                  this._onBlockDeselect.bind(this)
                );
            },
          },
          {
            key: "register",
            value: function (e, t) {
              var i = this;
              (this.constructors[e] = t),
                h
                  .nodeListToArray(
                    document.querySelectorAll(
                      "[data-section-type=".concat(e, "]")
                    )
                  )
                  .forEach(function (e) {
                    i._createInstance(e, t);
                  });
            },
          },
          {
            key: "_findInstance",
            value: function (e, t, i) {
              for (var n = 0; n < e.length; n++) if (e[n][t] === i) return e[n];
            },
          },
          {
            key: "_removeInstance",
            value: function (e, t, i) {
              for (var n = e.length; n--; )
                if (e[n][t] === i) {
                  e.splice(n, 1);
                  break;
                }
              return e;
            },
          },
          {
            key: "_onSectionLoad",
            value: function (e) {
              var t = e.target.querySelector("[data-section-id]");
              t && this._createInstance(t);
            },
          },
          {
            key: "_onSectionUnload",
            value: function (e) {
              var t = this._findInstance(
                this.instances,
                "id",
                e.detail.sectionId
              );
              t &&
                ("function" == typeof t.onUnload && t.onUnload(e),
                (this.instances = this._removeInstance(
                  this.instances,
                  "id",
                  e.detail.sectionId
                )));
            },
          },
          {
            key: "_onSelect",
            value: function (e) {
              var t = this._findInstance(
                this.instances,
                "id",
                e.detail.sectionId
              );
              t && "function" == typeof t.onSelect && t.onSelect(e);
            },
          },
          {
            key: "_onDeselect",
            value: function (e) {
              var t = this._findInstance(
                this.instances,
                "id",
                e.detail.sectionId
              );
              t && "function" == typeof t.onDeselect && t.onDeselect(e);
            },
          },
          {
            key: "_onReorder",
            value: function (e) {
              var t = this._findInstance(
                this.instances,
                "id",
                e.detail.sectionId
              );
              t && "function" == typeof t.onReorder && t.onReorder(e);
            },
          },
          {
            key: "_onBlockSelect",
            value: function (e) {
              var t = this._findInstance(
                this.instances,
                "id",
                e.detail.sectionId
              );
              t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            },
          },
          {
            key: "_onBlockDeselect",
            value: function (e) {
              var t = this._findInstance(
                this.instances,
                "id",
                e.detail.sectionId
              );
              t &&
                "function" == typeof t.onBlockDeselect &&
                t.onBlockDeselect(e);
            },
          },
          {
            key: "_createInstance",
            value: function (e, t) {
              var i = e.getAttribute("data-section-id"),
                n = e.getAttribute("data-section-type");
              if (void 0 !== (t = t || this.constructors[n])) {
                var o = Object.assign(new t(e), {
                  id: i,
                  type: n,
                  container: e,
                });
                this.instances.push(o);
              }
            },
          },
        ]),
        t
      );
    })(),
    ne = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          this._setupAnimation();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.intersectionObserver.disconnect(), this.timeline.kill();
            },
          },
          {
            key: "_setupAnimation",
            value: function () {
              var e = this;
              this.intersectionObserver &&
                this.intersectionObserver.disconnect(),
                (this.timeline = new TimelineLite({
                  delay: 0.5,
                })),
                window.theme.showElementStaggering &&
                  ((this.intersectionObserver = new IntersectionObserver(
                    this._reveal.bind(this)
                  )),
                  h
                    .nodeListToArray(
                      this.element.querySelectorAll(
                        ".ProductList .ProductItem, .ArticleList .ArticleItem"
                      )
                    )
                    .forEach(function (t) {
                      e.intersectionObserver.observe(t);
                    }));
            },
          },
          {
            key: "_reveal",
            value: function (e) {
              var t = this,
                i = [];
              e.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (i.push(e.target),
                  t.intersectionObserver.unobserve(e.target));
              }),
                0 !== i.length &&
                  this.timeline.staggerFromTo(
                    i,
                    0.6,
                    {
                      autoAlpha: 0,
                      y: 25,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                    },
                    0.2
                  );
            },
          },
        ]),
        t
      );
    })(),
    oe = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.carousel = new d(
            this.element.querySelector("[data-flickity-config]")
          )),
          new w(this.element);
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.carousel.destroy();
            },
          },
        ]),
        t
      );
    })(),
    se = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.usePocketMode = c.matchesBreakpoint("pocket")),
          (this.pocketActivatorButton = this.element.querySelector(
            '[data-action="open-look"]'
          )),
          this._createOuterCarousel(),
          this._createPocketPopovers(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.outerCarousel.destroy(),
                this.innerCarousels.forEach(function (e) {
                  e.forEach(function (e) {
                    return e.destroy();
                  });
                }),
                this.popovers.forEach(function (e) {
                  return e.destroy();
                }),
                this.delegateElement.off();
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              this.outerCarousel.selectCell(
                e.target.getAttribute("data-slide-index"),
                !0,
                !e.detail.load
              );
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                ".ShopTheLook__Dot",
                this._onDotClicked.bind(this)
              );
            },
          },
          {
            key: "_createPocketPopovers",
            value: function () {
              var e = this;
              (this.popovers = []),
                h
                  .nodeListToArray(this.element.querySelectorAll(".Popover"))
                  .forEach(function (t) {
                    e.popovers.push(
                      new g(t, {
                        activator: e.pocketActivatorButton,
                        showOverlay: !1,
                        onOpen: e._openPocketZoom.bind(e),
                        onClose: e._closePocketZoom.bind(e),
                      })
                    );
                  });
            },
          },
          {
            key: "_createOuterCarousel",
            value: function () {
              var e = this;
              (this.outerCarousel = new d(
                this.element.querySelector(".ShopTheLook"),
                {
                  onSelect: this._onLookChanged.bind(this),
                }
              )),
                (this.innerCarousels = new Array(
                  this.outerCarousel.flickityInstance.cells.length
                ));
              for (var t = 0; t !== this.innerCarousels.length; ++t)
                this.innerCarousels[t] = [];
              h
                .nodeListToArray(
                  this.element.querySelectorAll(".ShopTheLook__ProductList")
                )
                .forEach(function (t) {
                  var i = parseInt(t.getAttribute("data-look-index"));
                  e.innerCarousels[i].push(
                    new d(t, {
                      onSelect: e._onProductChanged.bind(e),
                    })
                  ),
                    t.insertBefore(
                      t.querySelector(".flickity-viewport"),
                      t.querySelector(".ShopTheLook__ViewButton")
                    );
                }),
                this.outerCarousel.resize();
            },
          },
          {
            key: "_onLookChanged",
            value: function (e, t) {
              this.pocketActivatorButton.setAttribute(
                "aria-controls",
                "".concat(t.getAttribute("id"), "-popover")
              );
            },
          },
          {
            key: "_onProductChanged",
            value: function (e, t) {
              var i = this.outerCarousel.getSelectedCell(),
                n = null;
              h
                .nodeListToArray(i.querySelectorAll(".ShopTheLook__Dot"))
                .forEach(function (t, i) {
                  t.classList.remove("is-active"),
                    i === e && (t.classList.add("is-active"), (n = t));
                }),
                i
                  .querySelector(".ShopTheLook__ViewButton")
                  .setAttribute("href", t.getAttribute("data-product-url")),
                i.dispatchEvent(
                  new CustomEvent("product:changed", {
                    detail: {
                      dot: n,
                    },
                  })
                );
            },
          },
          {
            key: "_onDotClicked",
            value: function (e, t) {
              var i = !1,
                n = !1,
                o = this.outerCarousel.getSelectedIndex();
              this.popovers.forEach(function (e) {
                e.isOpen && ((n = !0), (i = !0));
              }),
                this.innerCarousels[o].forEach(function (e) {
                  e.selectCell(
                    parseInt(t.getAttribute("data-product-index")) - 1,
                    !1,
                    i
                  );
                }),
                this.usePocketMode && !n && this.popovers[o].open();
            },
          },
          {
            key: "_openPocketZoom",
            value: function (e) {
              var t = this;
              this._calculateImageTransform(e),
                fastdom.mutate(function () {
                  (document.getElementById(
                    "shopify-section-header"
                  ).style.cssText =
                    "transform: translateY(-100%); transition: transform 0.3s ease-in-out;"),
                    t.outerCarousel.flickityInstance.unbindDrag(),
                    t.outerCarousel.flickityInstance.element.classList.add(
                      "is-zoomed"
                    ),
                    t.outerCarousel
                      .getSelectedCell()
                      .classList.add("is-expanded");
                });
            },
          },
          {
            key: "_calculateImageTransform",
            value: function (e) {
              var t = this,
                i = this.outerCarousel.getSelectedCell();
              fastdom.measure(function () {
                var n =
                    window.innerWidth /
                    (i.offsetWidth -
                      2 * parseInt(window.getComputedStyle(i).paddingLeft)),
                  o = Math.round(i.offsetHeight * n),
                  s = Math.round(
                    Math.max(
                      o - (window.innerHeight - e.element.offsetHeight),
                      0
                    )
                  ),
                  a = o - s,
                  r = Math.round(
                    -(i.getBoundingClientRect().top - (o - i.offsetHeight) / 2)
                  ),
                  l = Math.round(r - s);
                (t._calculateTransformForDotListener = function (e) {
                  var i = Math.round(
                      (e.detail.dot.offsetTop + e.detail.dot.offsetHeight / 2) *
                        n
                    ),
                    o = Math.round(i - a / 2),
                    s = Math.min(Math.max(r - o, l), r);
                  fastdom.mutate(function () {
                    t.outerCarousel.flickityInstance.viewport.style.transform =
                      "translate3d(0, "
                        .concat(Math.round(s), "px, 0) scale(")
                        .concat(n, ")");
                  });
                }),
                  i.addEventListener(
                    "product:changed",
                    t._calculateTransformForDotListener
                  ),
                  i.dispatchEvent(
                    new CustomEvent("product:changed", {
                      detail: {
                        dot: i.querySelector(".ShopTheLook__Dot.is-active"),
                      },
                    })
                  );
              });
            },
          },
          {
            key: "_closePocketZoom",
            value: function () {
              var e = this,
                t = this.outerCarousel.getSelectedCell();
              t.removeEventListener(
                "product:changed",
                this._calculateTransformForDotListener
              ),
                fastdom.mutate(function () {
                  (document.getElementById(
                    "shopify-section-header"
                  ).style.cssText =
                    "transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;"),
                    e.outerCarousel.flickityInstance.bindDrag(),
                    e.outerCarousel.flickityInstance.element.classList.remove(
                      "is-zoomed"
                    ),
                    (e.outerCarousel.flickityInstance.viewport.style.transform =
                      null),
                    t.classList.remove("is-expanded");
                });
            },
          },
        ]),
        t
      );
    })(),
    ae = (function () {
      function t(i) {
        e(this, t), (this.element = i), (this.sidebarDrawer = new v(i));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.sidebarDrawer.destroy();
            },
          },
          {
            key: "onSelect",
            value: function () {
              this.sidebarDrawer.open();
            },
          },
          {
            key: "onDeselect",
            value: function () {
              this.sidebarDrawer.close();
            },
          },
        ]),
        t
      );
    })(),
    re = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.slideshow = new d(
            this.element.querySelector("[data-flickity-config]"),
            {
              onSelect: this._onSlideChanged.bind(this),
            }
          )),
          (this.selectedSlide = null),
          (this.shouldAnimate = !0),
          (this.timeline = new TimelineLite({
            delay: window.theme.showPageTransition ? 0.5 : 0,
          })),
          this.slideshow.flickityInstance.cells.length > 0 &&
            this._transitionToSlide(
              this.slideshow.flickityInstance.selectedCell.element,
              !0
            ),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.slideshow.destroy(),
                this.timeline.kill(),
                this.delegateElement.off(),
                document.removeEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                );
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              this.slideshow.flickityInstance.options.autoPlay &&
                this.slideshow.flickityInstance.stopPlayer(),
                (this.shouldAnimate = !e.detail.load),
                this.slideshow.selectCell(
                  e.target.getAttribute("data-slide-index"),
                  !1,
                  !e.detail.load
                );
            },
          },
          {
            key: "onBlockDeselect",
            value: function () {
              (this.shouldAnimate = !0),
                this.slideshow.flickityInstance.options.autoPlay &&
                  this.slideshow.flickityInstance.playPlayer();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              (this._onBreakpointChangedListener =
                this._onBreakpointChanged.bind(this)),
                this.delegateElement.on(
                  "mouseenter",
                  ".Button",
                  this._pauseSlideshow.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "mouseleave",
                  ".Button",
                  this._resumeSlideshow.bind(this),
                  !0
                ),
                document.addEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                );
            },
          },
          {
            key: "_pauseSlideshow",
            value: function () {
              this.slideshow.flickityInstance.options.autoPlay &&
                this.slideshow.flickityInstance.pausePlayer();
            },
          },
          {
            key: "_resumeSlideshow",
            value: function () {
              this.slideshow.flickityInstance.options.autoPlay &&
                this.slideshow.flickityInstance.unpausePlayer();
            },
          },
          {
            key: "_onSlideChanged",
            value: function (e, t) {
              this._transitionToSlide(t);
            },
          },
          {
            key: "_transitionToSlide",
            value: function (e) {
              var t = this;
              this.timeline.clear(),
                this.selectedSlide &&
                  (this._slideLeave(this.selectedSlide),
                  this.timeline.addLabel(
                    "enter",
                    this.shouldAnimate ? "-=0.4" : 0
                  )),
                this._lazyLoadNextImage(),
                this.timeline.fromTo(
                  e,
                  this.selectedSlide && this.shouldAnimate ? 0.3 : 0,
                  {
                    autoAlpha: 0,
                  },
                  {
                    autoAlpha: 1,
                    ease: Cubic.easeInOut,
                  },
                  "enter"
                ),
                this.slideshow.flickityInstance.options.autoPlay &&
                  "playing" === this.slideshow.flickityInstance.player.state &&
                  this.slideshow.flickityInstance.pausePlayer(),
                h
                  .nodeListToArray(e.querySelectorAll(".Slideshow__Image"))
                  .forEach(function (i) {
                    i.classList.contains("Image--lazyLoading") ||
                    i.classList.contains("Image--lazyLoad")
                      ? i.addEventListener(
                          "lazyloaded",
                          t._slideEnter.bind(t, e)
                        )
                      : t._slideEnter(e);
                  }),
                (this.selectedSlide = e);
            },
          },
          {
            key: "_slideLeave",
            value: function (e) {
              var t = e.querySelector(".SectionHeader"),
                i = e.querySelector(".SectionHeader__ButtonWrapper");
              this.timeline.fromTo(
                e,
                this.shouldAnimate ? 0.3 : 0,
                {
                  autoAlpha: 1,
                },
                {
                  autoAlpha: 0,
                  ease: Cubic.easeInOut,
                  delay: this.shouldAnimate ? 0.35 : 0,
                }
              ),
                t &&
                  this.timeline.fromTo(
                    t,
                    this.shouldAnimate ? 0.4 : 0,
                    {
                      autoAlpha: 1,
                      y: 0,
                    },
                    {
                      autoAlpha: 0,
                      y: 20,
                      ease: Cubic.easeIn,
                    },
                    0
                  ),
                i &&
                  this.timeline.fromTo(
                    i,
                    this.shouldAnimate ? 0.4 : 0,
                    {
                      autoAlpha: 1,
                      y: 0,
                    },
                    {
                      autoAlpha: 0,
                      y: 10,
                      ease: Cubic.easeIn,
                    },
                    0
                  );
            },
          },
          {
            key: "_slideEnter",
            value: function (e) {
              var t = e.querySelectorAll(".Slideshow__Image"),
                i = e.querySelector(".SectionHeader"),
                n = e.querySelector(".SectionHeader__ButtonWrapper");
              this.slideshow.flickityInstance.options.autoPlay &&
                "paused" === this.slideshow.flickityInstance.player.state &&
                this.slideshow.flickityInstance.unpausePlayer(),
                window.CSS &&
                  window.CSS.supports(
                    "(object-fit: cover) or (-o-object-fit: cover)"
                  ) &&
                  (window.theme.showImageZooming
                    ? this.timeline.fromTo(
                        t,
                        this.shouldAnimate ? 1.2 : 0,
                        {
                          opacity: 0,
                          scale: 1.2,
                        },
                        {
                          opacity: 1,
                          scale: 1,
                          ease: Quad.easeOut,
                        },
                        "enter"
                      )
                    : this.timeline.fromTo(
                        t,
                        this.shouldAnimate ? 1.2 : 0,
                        {
                          opacity: 0,
                        },
                        {
                          opacity: 1,
                          ease: Quad.easeOut,
                        },
                        "enter"
                      )),
                i &&
                  this.timeline.fromTo(
                    i,
                    this.shouldAnimate ? 0.8 : 0,
                    {
                      autoAlpha: 0,
                      y: 30,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                      delay: this.shouldAnimate ? 0.8 : 0,
                      ease: Cubic.easeOut,
                    },
                    "enter"
                  ),
                n &&
                  this.timeline.fromTo(
                    n,
                    this.shouldAnimate ? 0.8 : 0,
                    {
                      autoAlpha: 0,
                      y: 20,
                    },
                    {
                      autoAlpha: 1,
                      y: 0,
                      delay: this.shouldAnimate ? 0.8 : 0,
                      ease: Cubic.easeOut,
                    },
                    "enter"
                  );
            },
          },
          {
            key: "_lazyLoadNextImage",
            value: function () {
              var e = this.slideshow.flickityInstance.selectedIndex,
                t = c.getCurrentBreakpoint();
              if (this.slideshow.flickityInstance.cells.length - 1 > e) {
                var i = this.slideshow.flickityInstance.cells[e + 1].element,
                  n = h.nodeListToArray(
                    i.querySelectorAll(".Slideshow__ImageContainer")
                  ),
                  o = null;
                (o = "phone" === t ? n[0] : n[1]),
                  window.lazySizes &&
                    o &&
                    o.classList.contains("Image--lazyLoad") &&
                    lazySizes.loader.unveil(o.firstElementChild);
              }
            },
          },
          {
            key: "_onBreakpointChanged",
            value: function (e) {
              (("phone" === e.detail.previousBreakpoint &&
                "phone" !== e.detail.currentBreakpoint) ||
                ("phone" !== e.detail.previousBreakpoint &&
                  "phone" === e.detail.currentBreakpoint)) &&
                ((this.selectedSlide = null),
                this._transitionToSlide(
                  this.slideshow.flickityInstance.selectedElement
                ));
            },
          },
        ]),
        t
      );
    })(),
    le = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.navItems = h.nodeListToArray(
            this.element.querySelectorAll(".TestimonialNav__Item")
          )),
          (this.carousel = new d(
            this.element.querySelector(".TestimonialList"),
            {
              onSelect: this._testimonialChanged.bind(this),
            }
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.carousel.destroy(), this.delegateElement.off("click");
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              this.carousel.selectCell(
                e.target.getAttribute("data-slide-index"),
                !0
              );
            },
          },
          {
            key: "onBlockDeselect",
            value: function () {
              this.carousel.unpausePlayer();
            },
          },
          {
            key: "_testimonialClicked",
            value: function (e, t) {
              this.carousel.pausePlayer(),
                this.carousel.selectCell(
                  parseInt(t.getAttribute("data-index"))
                ),
                this.carousel.unpausePlayer();
            },
          },
          {
            key: "_testimonialChanged",
            value: function (e) {
              this.navItems.forEach(function (t, i) {
                t.classList.remove("is-selected"),
                  e === i && t.classList.add("is-selected");
              });
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                ".TestimonialNav__Item",
                this._testimonialClicked.bind(this)
              );
            },
          },
        ]),
        t
      );
    })(),
    ce = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.items = h.nodeListToArray(
            this.element.querySelectorAll(".Timeline__Item")
          )),
          (this.navItems = h.nodeListToArray(
            this.element.querySelectorAll(".Timeline__NavItem")
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function () {
              this.delegateElement.off("click");
            },
          },
          {
            key: "onBlockSelect",
            value: function (e) {
              this.navItems[
                parseInt(e.target.getAttribute("data-index"))
              ].click();
            },
          },
          {
            key: "_attachListeners",
            value: function () {
              this.delegateElement.on(
                "click",
                ".Timeline__NavItem",
                this._clickOnNavItem.bind(this)
              );
            },
          },
          {
            key: "_clickOnNavItem",
            value: function (e, t) {
              var i = this.items[parseInt(t.getAttribute("data-index"))];
              if (!i.classList.contains("is-selected")) {
                var n = !1,
                  o = t.parentNode,
                  s = 0;
                fastdom.measure(function () {
                  var e = o.scrollWidth,
                    i = o.offsetWidth;
                  if ((n = i < e)) {
                    var a = t.offsetLeft,
                      r = null,
                      l =
                        (r =
                          a <= i - (a + t.offsetWidth)
                            ? t.previousElementSibling || t
                            : t.nextElementSibling || t).offsetLeft -
                        o.scrollLeft,
                      c = l + r.offsetWidth;
                    c > i ? (s = c - i) : l < 0 && (s = l);
                  }
                }),
                  fastdom.mutate(function () {
                    n &&
                      o.scrollBy({
                        behavior: "smooth",
                        left: s,
                      }),
                      t.classList.add("is-selected"),
                      h.getSiblings(t, ".is-selected").forEach(function (e) {
                        e.classList.remove("is-selected");
                      }),
                      i.classList.add("is-selected"),
                      h.getSiblings(i, ".is-selected").forEach(function (e) {
                        e.classList.remove("is-selected");
                      });
                  });
              }
            },
          },
        ]),
        t
      );
    })(),
    de = (function (t) {
      !(function (e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0,
          },
        })),
          t && o(e, t);
      })(u, r(HTMLElement));
      var a,
        c,
        d =
          ((a = u),
          (c = s()),
          function () {
            var e,
              t = n(a);
            if (c) {
              var i = n(this).constructor;
              e = Reflect.construct(t, arguments, i);
            } else e = t.apply(this, arguments);
            return l(this, e);
          });

      function u() {
        return e(this, u), d.apply(this, arguments);
      }
      return (
        i(u, [
          {
            key: "connectedCallback",
            value: function () {
              var e = this;
              (this.rangeLowerBound = this.querySelector(
                ".price-range__range-group input:first-child"
              )),
                (this.rangeHigherBound = this.querySelector(
                  ".price-range__range-group input:last-child"
                )),
                (this.textInputLowerBound = this.querySelector(
                  ".price-range__input:first-child input"
                )),
                (this.textInputHigherBound = this.querySelector(
                  ".price-range__input:last-child input"
                )),
                this.textInputLowerBound.addEventListener("focus", function () {
                  return e.textInputLowerBound.select();
                }),
                this.textInputHigherBound.addEventListener(
                  "focus",
                  function () {
                    return e.textInputHigherBound.select();
                  }
                ),
                this.textInputLowerBound.addEventListener(
                  "change",
                  function (t) {
                    (t.target.value = Math.max(
                      Math.min(
                        parseInt(t.target.value),
                        parseInt(e.textInputHigherBound.value || t.target.max) -
                          1
                      ),
                      t.target.min
                    )),
                      (e.rangeLowerBound.value = t.target.value),
                      e.rangeLowerBound.parentElement.style.setProperty(
                        "--range-min",
                        "".concat(
                          (parseInt(e.rangeLowerBound.value) /
                            parseInt(e.rangeLowerBound.max)) *
                            100,
                          "%"
                        )
                      );
                  }
                ),
                this.textInputHigherBound.addEventListener(
                  "change",
                  function (t) {
                    (t.target.value = Math.min(
                      Math.max(
                        parseInt(t.target.value),
                        parseInt(e.textInputLowerBound.value || t.target.min) +
                          1
                      ),
                      t.target.max
                    )),
                      (e.rangeHigherBound.value = t.target.value),
                      e.rangeHigherBound.parentElement.style.setProperty(
                        "--range-max",
                        "".concat(
                          (parseInt(e.rangeHigherBound.value) /
                            parseInt(e.rangeHigherBound.max)) *
                            100,
                          "%"
                        )
                      );
                  }
                ),
                this.rangeLowerBound.addEventListener("change", function (t) {
                  (e.textInputLowerBound.value = t.target.value),
                    e.textInputLowerBound.dispatchEvent(
                      new Event("change", {
                        bubbles: !0,
                      })
                    );
                }),
                this.rangeHigherBound.addEventListener("change", function (t) {
                  (e.textInputHigherBound.value = t.target.value),
                    e.textInputHigherBound.dispatchEvent(
                      new Event("change", {
                        bubbles: !0,
                      })
                    );
                }),
                this.rangeLowerBound.addEventListener("input", function (t) {
                  (t.target.value = Math.min(
                    parseInt(t.target.value),
                    parseInt(e.textInputHigherBound.value || t.target.max) - 1
                  )),
                    t.target.parentElement.style.setProperty(
                      "--range-min",
                      "".concat(
                        (parseInt(t.target.value) / parseInt(t.target.max)) *
                          100,
                        "%"
                      )
                    ),
                    (e.textInputLowerBound.value = t.target.value);
                }),
                this.rangeHigherBound.addEventListener("input", function (t) {
                  (t.target.value = Math.max(
                    parseInt(t.target.value),
                    parseInt(e.textInputLowerBound.value || t.target.min) + 1
                  )),
                    t.target.parentElement.style.setProperty(
                      "--range-max",
                      "".concat(
                        (parseInt(t.target.value) / parseInt(t.target.max)) *
                          100,
                        "%"
                      )
                    ),
                    (e.textInputHigherBound.value = t.target.value);
                });
            },
          },
        ]),
        u
      );
    })();
  window.customElements.define("price-range", de),
    (function () {
      new m(),
        new y(),
        new c(),
        "password" !== window.theme.pageType &&
          "gift_card" !== window.theme.pageType &&
          new f();
      var e,
        t,
        i,
        n,
        o,
        s,
        a = new ie();
      a.register("header", Q),
        a.register("footer", K),
        a.register("sidebar-menu", ae),
        a.register("cart", N),
        a.register("newsletter-popup", X),
        a.register("slideshow", re),
        a.register("collection-list", V),
        a.register("article-list", H),
        a.register("featured-product", W),
        a.register("image-with-text-block", Z),
        a.register("timeline", ce),
        a.register("map", G),
        a.register("featured-collections", U),
        a.register("shop-the-look", se),
        a.register("testimonials", le),
        a.register("background-video", j),
        a.register("product", ee),
        a.register("product-recommendations", $),
        a.register("collection", F),
        a.register("article-list", H),
        a.register("article", B),
        a.register("faq", z),
        a.register("login", J),
        a.register("addresses", D),
        a.register("gift-card", Y),
        a.register("search", ne),
        a.register("recently-viewed-products", te),
        a.register("shop-now", oe),
        (Flickity.defaults.dragThreshold = 7),
        (t = !1),
        document.body.addEventListener("touchstart", function (i) {
          i.target.closest(".flickity-slider")
            ? ((t = !0),
              (e = {
                x: i.touches[0].pageX,
                y: i.touches[0].pageY,
              }))
            : (t = !1);
        }),
        document.body.addEventListener(
          "touchmove",
          function (i) {
            if (t && i.cancelable) {
              var n = {
                x: i.touches[0].pageX - e.x,
                y: i.touches[0].pageY - e.y,
              };
              Math.abs(n.x) > Flickity.defaults.dragThreshold &&
                i.preventDefault();
            }
          },
          {
            passive: !1,
          }
        ),
        h
          .nodeListToArray(document.querySelectorAll(".Rte table"))
          .forEach(function (e) {
            e.outerHTML = '<div class="TableWrapper">' + e.outerHTML + "</div>";
          }),
        h
          .nodeListToArray(document.querySelectorAll(".Rte iframe"))
          .forEach(function (e) {
            (-1 === e.src.indexOf("youtube") &&
              -1 === e.src.indexOf("youtu.be") &&
              -1 === e.src.indexOf("vimeo")) ||
              ((e.outerHTML =
                '<div class="VideoWrapper">' + e.outerHTML + "</div>"),
              (e.src = e.src));
          }),
        (i = new domDelegate.Delegate(document.body)),
        (n = document.querySelector(".AnnouncementBar")),
        i.on("click", '[href^="#"], [data-href]', function (e, t) {
          var i = t.hasAttribute("href")
            ? t.getAttribute("href")
            : t.getAttribute("data-href");
          if ("#" !== i && "#main" !== i) {
            var o = document.querySelector(i),
              s = parseInt(t.getAttribute("data-offset") || 0);
            if (
              (n && (s -= n.clientHeight),
              t.hasAttribute("data-focus-on-click"))
            ) {
              var a = window.pageYOffset;
              o.focus({
                preventScroll: !0,
              }),
                window.pageYOffset !== a &&
                  window.scrollTo(window.pageXOffset, a),
                o.focus();
            }
            window.scrollTo({
              behavior: "smooth",
              top: o.offsetTop - s,
            }),
              e.preventDefault();
          }
        }),
        (o = window.innerWidth),
        (s = document.getElementById("shopify-section-header")),
        window.addEventListener("resize", function () {
          var e = -1;
          fastdom.measure(function () {
            e = window.innerWidth;
          }),
            fastdom.mutate(function () {
              e !== o &&
                ((o = e),
                document.documentElement.style.setProperty(
                  "--window-height",
                  window.innerHeight + "px"
                ),
                s &&
                  document.documentElement.style.setProperty(
                    "--header-height",
                    s.clientHeight + "px"
                  ));
            });
        }),
        (function () {
          window.addEventListener("keydown", function e(t) {
            9 === t.keyCode &&
              (document.body.classList.add("is-tabbing"),
              window.removeEventListener("keydown", e));
          });
        })(),
        window.theme.showPageTransition && _.getInstance();
    })();
});
